{
    "headerData1": "MyHelp",
    "headerData2": "Dein KI-Assistent für IT-Support",
    "headerMessage": "Nutze <span class='me8eon'>MyHelp</span>, um IT-Probleme zu beheben, Schritt-für-Schritt-Anleitungen zu folgen oder an den richtigen IT-Support weitergeleitet zu werden.",
    "loginLable": "Login",
    "logOff": "Abmelden",
    "logIn": "Anmelden",
    "userName": "Profilname",
    "switchLanguage": "Sprache wechseln",
    "switchRole": "Rolle wechseln",
    "new": "Neu",
    "whatsnew": "Neuigkeiten",
    "whatsnewtt": "Über Neuerungen erfahren",
    "organiseTiles": "Kacheln organisieren",
    "confirm": "Bestätigen",
    "cancel": "abbrechen",
    "close": "Schließen",
    "reset": "Zurücksetzen",
    "continue_Tour": "Tour fortsetzen",
    "skip_Tour": "Tour überspringen",
    "save": "Speichern",
    "submit": "Einreichen",
    "delete": "Löschen",
    "trash_bin": "Löschen",
    "edit": "Bearbeiten",
    "yes": "Ja",
    "no": "Nein",
    "feedbackWidget": "Feedback",
    "registerLable": "Zur Anmeldung ",
    "underDevelopmentMsg": "Diese Seite wird überarbeitet",
    "apiFailDefaultMsg": "Etwas ist schiefgelaufen. Bitte versuche es später noch einmal.",
    "more": "weitere",
    "searchResult": "Suchergebnisse",
    "showAll": "Alle anzeigen",
    "showRelevant": "Relevante anzeigen",
    "assistantTabTooltip": "Assistance beantwortet deine Fragen, indem es in Echtzeit in den internen E.ON-Ressourcen sucht. Es liefert klare, leicht verständliche Antworten mit Quellen, damit du den Informationen vertrauen kannst",
    "searchTabTooltip": "E.ON Suche ist eine herkömmliche Suche, die dir schnell dabei hilft, Informationen aus verschiedenen E.ON-Quellen und deinen eigenen Daten zu finden. Sie liefert die relevantesten Ergebnisse und zeigt Links zu den Quellen",
    "landingPage": {
        "hello": "Hallo",
        "title": "wie kann ich weiterhelfen?",
        "searchApps": "Apps",
        "suggestions": "Vorschläge"
    },
    "footer": {
        "copyrights": "Urheberrechte Inhalt",
        "imprint": "Impressum",
        "privacyPolicy": "Datenschutz",
        "termsofUse": "AGB",
        "contact": "Kontakt",
        "PKI": "PKI",
        "privacySettings": "Datenschutz-Einstellungen",
        "aboutMe8EON": "über MyHelp"
    },
    "tilePage": {
        "backToSearch": "zurück zur vorherigen Seite",
        "myInboxCountSuffix": "Ausstehend"
    },
    "myApprovalDataTable": {
        "FilterLable": {
            "all": "Alle",
            "leaveApptoval": "Urlaubsgenehmigung",
            "timeSheet": "Stundenzettel",
            "claim": "Beanspruchen",
            "serviceRequest": "Service-Anfrage"
        },
        "tableData": {
            "approve": "Genehmigen",
            "reject": "ablehnen",
            "requestId": "Anfrage ID",
            "description": "Beschreibung",
            "requestedBy": "Angefordert von",
            "requestedType": "Angeforderter Typ",
            "requestedDate": "Wunschtermin",
            "status": "Status"
        }
    },
    "appData": {
        "time": "Zeiterfassung",
        "meeting": "Raumbuchungen",
        "approval": "Meine Genehmigungen",
        "pr": "Bestellanforderung erstellen",
        "pra": "Erweiterte Bestellanforderung erstellen",
        "processing": "My Inbox",
        "hr": "HR Portal",
        "hrLabel": "HR Portal",
        "concur": "Concur-Reisebuchung und -Kosten",
        "password": "Zurücksetzen des SAP-Passworts",
        "ariba": "Ariba – Classic und Classic+",
        "itresources": "IT-Ressourcen",
        "incident": "Vorfälle",
        "myassets": "Meine Geräte",
        "order": "Bestellungen",
        "beeline": "Beeline",
        "prisma": "Prisma",
        "gertrud": "Gertrud",
        "notification": "Meldungsportal",
        "zuko": "Zuko",
        "eon_brand": "EON Brand Space",
        "pki": "PKI Portal",
        "mail": "Mailverteiler",
        "journey": "Fahrten und Veranstaltungen",
        "mygenius": "MyGenius",
        "ideeon": "idEE.ON",
        "ideenet": "IdeeNet",
        "dpf": "Personnel file - Digital Personnel File - DPF",
        "corpsac": "Corporate SAC",
        "corpportal": "Corporate Portal",
        "redwood": "Redwood Finance Automation",
        "eamsap200": "EAM (200)",
        "eamsap100": "EAM (100)",
        "sodsap": "SoD SAP Portal",
        "videon": "VidE.ON",
        "alteryx": "Alteryx",
        "ebam": "Banking: Bank Acc Mgmt (EBAM)",
        "egs": "E.ON Guarantee Solution",
        "epsnext": "EPSnext",
        "fisquantum": "FIS Quantum",
        "rms": "RMS - Risk Management",
        "slido": "Slido",
        "insightslibrary": "Insights Library",
        "getabstract": "getAbstract",
        "mypotential": "Achieving My Potential",
        "dsesoftware": "DSE Software",
        "whistleblowing": "E.ON Whistleblowing Solution",
        "maqsima": "MAQSIMA TMS",
        "digitalrulebook": "Paula Policy",
        "oneERP": "OneERP",
        "Perseus": "Vorfallsmeldung",
        "cateringportal": "Speiseplan",
        "westnetzregelwerke": "Regelwerke Westnetz",
        "werbemittel": "Werbemittel",
        "westenergie_brand": "Brand-Management-Portal",
        "compass": "Compass",
        "gradar": "Gradar",
        "beqom": "beqom",
        "kyc": "KYC",
        "talentry": "Talentry",
        "sam": "SAM",
        "enorm": "e-NORM",
        "redonline": "ROL",
        "tagetikcpm": "Tagetik CPM",
        "tagetikcpmerm": "Tagetik CPM and ERM",
        "smartguide": "Smart Guide",
        "tagetiksac": "Tagetik SAC",
        "myit": "my IT",
        "timehover": "Mit der CATS-App kannst du deine Arbeitszeiten und Aktivitäten einfach erfassen und verwalten, indem du alle relevanten Informationen und Funktionen an einem Ort hast.",
        "meetinghover": "Mit Gingco, unserem Raumbuchungstool, kannst du einfach deine Besprechungsräume und Ressourcen verwalten und planen, um eine effiziente Nutzung und Verfügbarkeit sicherzustellen, alles an einem Ort",
        "approvalhover": "Mit myInbox kannst du Rechnungen einfach und effizient freigeben, indem du alle relevanten Informationen und Aktionen an einem Ort hast.",
        "prhover": "Hier findest Du alle relevanten Funktionen,um eine Bestellung anzufordern. Im Konzern häufig auch als BANF bezeichnet.",
        "prahover": "Hier findest Du alle relevanten Funktionen,um eine Bestellung anzufordern. Im Konzern häufig auch als BANF bezeichnet.",
        "processinghover": "Mit myInbox kannst du Rechnungen einfach und effizient freigeben, indem du alle relevanten Informationen und Aktionen an einem Ort hast.",
        "hrhover": "Mit myHR kannst du bequem auf deine personalbezogenen Informationen und Aufgaben zugreifen und diese an einem Ort verwalten.",
        "concurhover": "Mit Concur kannst du deine Reise- und Spesenabrechnungen einfach verwalten und einreichen, indem du alle relevanten Informationen und Aktionen an einem Ort hast.",
        "passwordhover": "Hier kannst du die Zugangspasswörter zu deinen SAP Systemen einfach zurücksetzen lassen.",
        "aribahover": "Mit SAP Ariba kannst du deine Beschaffungsprozesse einfach verwalten, indem du alle relevanten Informationen und Werkzeuge an einem Ort hast.",
        "itresourceshover": "IT-Ressourcen",
        "myassetshover": "Meine IT Ausstattung",
        "orderhover": "Bestellungen",
        "incidenthover": "Vorfälle",
        "beelinehover": "Mit Beeline kannst du deine externe Belegschaft effizient verwalten und deine Personalbeschaffungsprozesse optimieren, indem du alle notwendigen Werkzeuge und Informationen an einem Ort hast",
        "prismahover": "PRISMA steht für Platform for Reporting on Incident and Sustainability Management and Auditing. Die Plattform unterstützt E.ON’s HSE Abteilung bei der Aufgabe, E.ON zu einem gesundheitsbewussten, sicheren und umweltbewussten Ort zu machen. PRISMA ist sowohl über das Web, als auch per App verfügbar.",
        "gertrudhover": "Gertrud",
        "notificationhover": "Meldungsportal",
        "zukohover": "Zuko",
        "eon_brandhover": "EON Brand Space",
        "pkihover": "PKI Portal",
        "mailhover": "Mailverteiler",
        "journeyhover": "Fahrten und Veranstaltungen",
        "mygeniushover": "MyGenius",
        "ideeonhover": "Idee.on ist eine Plattform, die es den Mitarbeitern ermöglicht, Ideen und Vorschläge für das Ideenmanagement einzureichen und zu bewerten. Sie ist darauf ausgelegt, einen kontinuierlichen Verbesserungsprozess in allen Bereichen des Unternehmens zu erleichtern.",
        "ideenethover": "IdeeNet ist eine Ideenmanagement Software im tatsächlichen Sinne des Wortes. Verschiedenste Ideen, also beispielsweise &#10;&bull; Zentrales BVW, dezentrales BVW und Mischformen &#10;&bull; Qualitätszirkel und KVP &#10;&bull; Fehlerhinweise und Reklamationen &#10;&bull; Arbeitnehmererfindungen &#10;können mit dieser Software effizient, in einer einheitlichen Ideen-Datenbank, aber mit verschiedenen Strategien abgewickelt werden.",
        "dpfhover": "Deine Personalakte hält weit mehr Dokumente für Dich bereit als die, die dauerhaft in MyHR zur Anzeige kommen! &#10;Stelle eine HR Anfrage und bitte um Zugriff auf Deine gesamte Personalakte! Nach einer fachlichen Überprüfung wird sie Dir via Direktlink zur Verfügung gestellt.",
        "corpsachover": "SAC ist ein leistungsstarkes Visualisierungstool mit fortschrittlichen Planungsfunktionen.",
        "corpportalhover": "Das Corporate-Portal ist eine zentrale interne Anwendungsplattform mit rollenbasierter Anwendungsintegration und -entwicklung für den Single-Sign-On-Zugriff auf SAP-Backends.",
        "redwoodhover": "Redwood FA wird verwendet, um die konsolidierten Finanzberichte zu planen und einzelne Aktivitäten zu automatisieren.",
        "eamsap200hover": "Enterprise Asset Management &#10;Umgebung für Eigenentwicklungen basierend auf der Business Technology Plattform (BTP) von SAP (ehemals SAP Cloud Plattform) - EAM-Konto für Grid-Cockpits, einschließlich der Cloud-Instanzen: Produktion, QA (Qualitätssicherung), Entwicklung und Staging.",
        "eamsap100hover": "Enterprise Asset Management &#10;Umgebung für Eigenentwicklungen basierend auf der Business Technology Plattform (BTP) von SAP (ehemals SAP Cloud Plattform) - EAM-Konto für Grid-Cockpits, einschließlich der Cloud-Instanzen: Produktion, QA (Qualitätssicherung), Entwicklung und Staging.",
        "sodsaphover": "Das SOD-Portal wurde entwickelt, um das Management von Funktionstrennung (Segregation of Duties, SOD) zu optimieren und zu digitalisieren. Durch die Digitalisierung der Identifikation, Überwachung und Behebung von SOD-Konflikten gewährleistet es die Einhaltung gesetzlicher Vorschriften und stärkt die Sicherheit der Organisation. Dieses Tool ist entscheidend für die Aufrechterhaltung eines robusten internen Kontrollsystems und den Schutz Ihrer Geschäftsabläufe.",
        "videonhover": "App zur Buchung von Dienstleistungen aus dem Video-/TV-Studio am Brüsseler Platz für eine Video-/TV-Produktion oder ein Streaming-Event.",
        "alteryxhover": "Datenanalyseplattform zur Erstellung analytischer Anwendungen und Workflows. &#10;Sie ermöglicht es den Nutzern, analytische Anwendungen zu verwalten und zu teilen, Workflows auszuführen sowie Ergebnisse innerhalb einer Serverumgebung abzurufen und zu berichten.",
        "ebamhover": "Elektronische Kontoverwaltung",
        "egshover": "Die E.ON SE übernimmt Bürgschaften und Garantien für BU's der Gruppe gegenüber externen Kreditgebern",
        "epsnexthover": "Zentrales elektronisches Bankentool für alle MU/BUs",
        "fisquantumhover": "Die FIS Quantum Treasury Management Solution wurde entwickelt, um die Effizienz und Wirksamkeit der Treasury-Aktivitäten Ihres Unternehmens zu verbessern. Diese cloud-native Plattform bietet Echtzeittransparenz über Liquidität und Zahlungsmittelbestände und ermöglicht dadurch fundiertere Entscheidungen im Kapital- und Risikomanagement. Mit fortschrittlichen Funktionen zur Verwaltung von Schulden, Investitionen und Compliance trägt sie zur Optimierung von Workflows und zur Verbesserung der finanziellen Leistungsfähigkeit bei.",
        "rmshover": "E.ON-weites Risikomanagementsystem (Kreditantragsbearbeitung und Kreditrisikomanagementsystem)",
        "slidohover": "Slido ist eine interaktive Plattform, die darauf ausgelegt ist, das Engagement des Publikums zu erhöhen und Einblicke während Live- oder virtuellen Veranstaltungen, Meetings und Präsentationen zu sammeln. Sie ermöglicht es den Nutzern, Live-Umfragen, Q&A-Sitzungen und Quizze in Echtzeit durchzuführen und so eine dynamische und partizipative Erfahrung für das Publikum zu schaffen.",
        "insightslibraryhover": "Insights Library ist das zentrale Wissensrepository von E.ON für Kunden- und Marktinformationen im Bereich Kundendienstleistungen.",
        "getabstracthover": "getAbstract ist die konzernweite Online-Bibliothek von E.ON mit Buchzusammenfassungen, Artikeln und weiteren Lernformaten, die alle geschäftsrelevanten Fähigkeiten (z.B. Soft Skills) abdecken",
        "mypotentialhover": "System für UK-Mitarbeiter und Manager zur Aufzeichnung ihrer Leistung, Ziele und Bewertungen.",
        "dsesoftwarehover": "Bildschirmtraining und Bewertungen für Gesundheit und Sicherheit",
        "whistleblowinghover": "Das Whistleblowing Tool oder auch Hinweisgebertool ermöglicht es allen Hinweisgebern, einen Fall anonym einzureichen. Dies kann über eine Web-Intake oder auch über eine E-Mail oder das Telefon erfolgen. Bei einem Anruf wird dazu die Stimme verzerrt.",
        "maqsimahover": "Verwaltung von Gefährdungsbeurteilungen, Betriebsanweisungen, Gefahrstoffen &#10;Maqsima hilft Ihnen, alle relevanten Gefährdungsbeurteilungen und Betriebsanweisungen schnell und einfach im Blick zu behalten und auf intelligente Weise auf dem neuesten Stand zu halten.",
        "digitalrulebookhover": "Paula Policy ist der KI‑basierte Assistent für E.ON‑Konzernrichtlinien und ermöglicht Mitarbeitenden einen schnellen und verständlichen Zugang zu People Guidelines, Function Policies und dem Code of Conduct. Sie beantwortet Fragen konsistent und zuverlässig und macht komplexe Richtlinien leicht zugänglich.",
        "oneERPhover": "Das one.ERP Portal ist eine zentrale Plattform innerhalb der Westenergie-Gruppe, die verschiedene ERP-bezogene Funktionen und Informationen bündelt. Es dient als Informations- und Steuerungsplattform für ERP-Nutzer und IT-Verantwortliche und ist Teil der übergreifenden Digitalisierungsstrategie der Gruppe.",
        "Perseushover": "Das Security-Portal ist ein zentraler Zugangspunkt für sicherheitsrelevante Vorfallmeldungen innerhalb der Westenergie- und Westnetz-Organisationen. Es wird häufig im Zusammenhang mit dem internen Perseus-Meldesystem verwendet, das speziell für die Bearbeitung von Sicherheitsvorfällen wie Geräteverlust, Diebstahl oder Datenschutzverletzungen vorgesehen ist.",
        "cateringportalhover": "Das Portal eon.cateringportal.io ist die digitale Plattform für die E.ON Canteen App. Es dient der Bereitstellung von Speiseplänen, Standortinformationen und weiteren Verpflegungsservices für Mitarbeitende von E.ON",
        "westnetzregelwerkehover": "Das Portal dient als zentrale Anlaufstelle für technische Regelwerke und Dokumentationen, die den Betrieb und die Verwaltung des Strom- und Gasnetzes betreffen. Es stellt sicher, dass alle relevanten Richtlinien, Normen und technischen Vorgaben für einen sicheren und effizienten Netzbetrieb verfügbar sind.",
        "werbemittelhover": "Der Westenergie Werbemittelshop ist eine Online-Plattform, über die Mitarbeitende und berechtigte Partner der Westenergie-Gruppe Werbeartikel und Kommunikationsmaterialien bestellen können.",
        "westenergie_brandhover": "Die Westenergie-Bilddatenbank sowie die Markenelemente und Design-Richtlinien der Westenergie-Gruppe. Zugriff auf alle Bestandteile unserer Marke, um Westenergie-Momente zu schaffen. Vom Brand Management System mit allen wichtigen Richtlinien für die Verwendung der Markenelemente wie Logo, Symbole und unserer Chatbox bis zur Medienbibliothek mit zahlreichen Bildern für sämtliche Gestaltungsvarianten.",
        "compasshover": "Compass ist die gruppenweite interne Kommunikationsplattform für E.ON-Nachrichten und Inhalte, Networking und Austausch zwischen Mitarbeitenden",
        "gradarhover": "Das Tool wird verwendet, um den Bewertungsprozess für leitende Mitarbeiter*innen anzustoßen.",
        "beqomhover": "Beqom wird konzernweit für die Verwaltung und Kommunikation der langfristigen Prämienpläne von E.ON verwendet. Es wird von HR, Buchhaltung, Steuerabteilung und Führungskräften genutzt. Neben Angelegenheiten der langfristigen Anreizpläne kann beqom auch zur Erstellung von Gehalts- und Bonusbriefen sowie Gesamtvergütungserklärungen verwendet werden.",
        "kychover": "Mit dem Know-Your-Counterpart (KYC)-Tool können Sie Geschäftspartner gemäß den Standardrichtlinien (z. B. PG-03) überprüfen.",
        "talentryhover": "Nutzen Sie diese Gelegenheit, um unsere aktuellen Stellenangebote mit talentierten Menschen in Ihrem Netzwerk zu teilen – Menschen, die mit ihrer Energie die Zukunft mitgestalten wollen.",
        "samhover": "In deisem Tool können die relevanten Sicherheitstrainings bearbeitet werden.",
        "enormhover": "e-NORM ist eine leistungsfähige Software zur Verwaltung, Bereitstellung undAktualisierung von Daten zu QS- oder Normendokumenten sowie der Verknüpfung mitzugehörigen Dateien.",
        "redonlinehover": "Der Red-on-line (ROL) Compliance Monitor vereinfacht das Management der regulatorischen Compliance, indem er Echtzeit-Updates zu Umwelt-, Gesundheits- und Sicherheitsvorschriften (EHS) bereitstellt. &#10;Er bietet Überwachungsfunktionen und Dashboards, die dabei helfen, Compliance-Probleme proaktiv anzugehen. &#10;Dieses Tool ist unerlässlich für die Aufrechterhaltung eines sicheren und regelkonformen Arbeitsplatzes, die Risikominimierung und die Steigerung der betrieblichen Effizienz.",
        "tagetikcpmhover": "Die Tagetik Corporate Performance Management (CPM)-Anwendung für Budgetierung & Planung, Konsolidierung, Risikomanagement und Management-Reporting (eingeführt durch Finance Excellence) der E.ON SE (Group Reporting). &#10;Die Hauptprozesse sind die Quartalsabschlüsse, die aufgrund harter Fristen für die Kapitalmarktkommunikation eine sehr hohe externe Relevanz haben.",
        "tagetikcpmermhover": "Die Tagetik Corporate Performance Management (CPM)- und Enterprise Risk Management (ERM)-Anwendung dient der Budgetierung & Planung, Konsolidierung, dem Risikomanagement und dem Management-Reporting (eingeführt durch Finance Excellence) der E.ON SE (Group Reporting). &#10;Die Hauptprozesse sind die Quartalsabschlüsse, die aufgrund harter Fristen für die Kapitalmarktkommunikation eine sehr hohe externe Relevanz haben.",
        "smartguidehover": "Der Smart Guide Hub ist ein Wiki, das redaktionell von einigen Kollegen gepflegt wird, um Richtlinien für ca. 4000 Nutzer in den Bereichen IFRS, Controlling, HGB und ESG bereitzustellen.",
        "tagetiksachover": "Tagetik Dashboard. &#10;Tagetik ist eine Anwendung für Budgetierung & Planung, Konsolidierung, Risikomanagement und Management-Reporting (eingeführt durch Finance Excellence) der E.ON SE (Group Reporting). &#10;Die Hauptprozesse sind die Quartalsabschlüsse, die aufgrund harter Fristen für die Kapitalmarktkommunikation eine sehr hohe externe Relevanz haben.",
        "myithover": "Deine Anlaufstelle für alles, was mit IT zu tun hat: Support, nützliche Links, Communities und die neuesten Nachrichten, über die Du Bescheid wissen musst.",
        "servicehub": "Service Hub",
        "servicehubhover": "Mit dem EON Service Hub kannst du ganz einfach neue Software und Hardware wie Laptops und Monitore anfordern und erhalte IT Unterstützung indem du Probleme meldest oder mit dem my IT support chattest – alles an einem Ort.",
        "SailPoint": "Identity Management Overview",
        "P29": "SAP EIC",
        "P83": "SAP EIC",
        "BIC": "BIC Cloud / BIC Process Design",
        "Celonis": "Celonis Process Mining",
        "Carsync": "Carsync Fuhrparkmanagement",
        "ISUSpace": "ISU/Space",
        "GNIS": "GNIS (EDI)",
        "ecount_EDI": "ecount EDI",
        "SAP_Datasphere_EDI": "SAP Datasphere EDI",
        "SailPointhover": "Mit SailPoint können Zugriffsrechte und Identitäten zentral verwaltet werden.",
        "P29hover": "Mit SAP EIC können Tickets und Kundenanfragen effizient bearbeitet und dokumentiert werden. Die Anwendung unterstützt den Austausch mit ECG und bietet eine zentrale Oberfläche für das Ticketing.",
        "P83hover": "Mit SAP EIC können Tickets und Kundenanfragen effizient bearbeitet und dokumentiert werden. Die Anwendung unterstützt den Austausch mit ECG und bietet eine zentrale Oberfläche für das Ticketing.",
        "BIChover": "Mit BIC Cloud können Geschäftsprozesse modelliert, analysiert und optimiert werden.",
        "Celonishover": "Process Mining: Analyse von Ist-Prozessen auf Basis von Event-Logs aus ERP-, CRM- und anderen Systemen. Execution Management: Automatisierung von Workflows und Handlungsempfehlungen. Prozessoptimierung: Identifikation von Ineffizienzen, z. B. in Purchase-to-Pay oder Order-to-Cash Prozessen. Integration: Anbindung an Systeme wie SAP, Salesforce, Oracle, etc.",
        "Carsynchover": "Mit Carsync können Dienstwagen und Fuhrparks effizient verwaltet, Fahrten dokumentiert und Kosten optimiert werden.",
        "ISUSpacehover": "Mit ISU/Space können Arbeitsplätze und Besprechungsräume einfach gebucht und verwaltet werden.",
        "GNIShover": "Mit GNIS können Stammdaten und Netzdaten für die Marktkommunikation (EDI) effizient verwaltet und ausgetauscht werden.",
        "ecount_EDIhover": "Mit eccount können EDI-relevante Stammdaten und Netzdaten verwaltet, ausgetauscht und analysiert werden.",
        "SAP_Datasphere_EDIhover": "Mit SAP Datasphere können Daten aus verschiedenen Quellen integriert, modelliert und für Analytics sowie Business-Entscheidungen bereitgestellt werden. Die Plattform unterstützt Self-Service, Data Governance und Echtzeit-Datenzugriff.",
        "ukhr": "UK HR App",
        "ukhrhover": "Your one stop shop for everything UK HR. From payslips to holiday booking and everything in between. Get started with our employee and manager guides or search all of HR below.",
        "CFLP": "CFLP",
        "CFLPhover": "Zentraler Einstiegspunkt für SAP-Systeme und Cloud Services.",
        "corporateWorkspace": "Corporate Workspace",
        "corporateWorkspacehover": "Mit SAP Build Work Zone, Advanced Edition, können Sie digitale Arbeitsbereichslösungen entwickeln, um die Benutzerproduktivität und -interaktion zu steigern. Sie zentralisiert den Zugriff auf relevante Geschäftsanwendungen, Prozesse, Informationen und Kommunikation an einem einheitlichen Einstiegspunkt, auf den Ihre Benutzer von jedem Gerät aus zugreifen können.",
        "SAPWebLaunchpad": "SAP Web Launchpad",
        "SAPWebLaunchpadhover": "Das SAP Web Launchpad bietet den Zugriff auf SAP-Systeme über das Web mit Fiori und WebGUI. Die personalisierbare Startseite inkl. Favoriten erlaubt den schnellen Zugriff auf die SAP-Systeme und Mandanten.",
        "PKI_Semnatura_Digitala_6781": "PKI - Digitale Signatur",
        "Users_Access_EER_9163": "RAPPS EER",
        "Evaluare_Personal_EER_2935": "Personalbewertung EER",
        "Sesizari_Administrare_Cladiri_EER_8543": "Meldungen zur Gebäudeverwaltung EER",
        "MRBS_EER_8445": "MRBS EER",
        "Delegatii_EER_1137": "Dienstreisen EER",
        "Users_Access_EER_5369": "Benutzerzugang EER",
        "Planificare_Concedii_EER_8588": "Urlaubsplanung EER",
        "Pontaje_si_Telemunca_EER_7087": "Zeiterfassung und Telearbeit EER",
        "BOT_6231": "BOT",
        "Bonusare_personal_6879": "Mitarbeiterbonus",
        "GRC_Request_5510": "GRC Request",
        "iPEN_Portal_3047": "iPEN Portal",
        "YourVoiceEON_0693": "YourVoice@E.ON",
        "ITPortal_5530": "IT-Portal (Süwag)",
        "Transf4m_Ticket_Tool_6635": "Transf4m Ticket Tool (Süwag)",
        "Speedikon_C_1281": "Speedikon C (Süwag)",
        "Speiseplan_8904": "Speiseplan (Süwag)",
        "Ariba_8690": "Ariba",
        "DiSch_20_0545": "DiSch 2.0",
        "ISMSMeldezentrale_9318": "ISMS-Meldezentrale (Süwag)",
        "SAP_Launchpad_8736": "SAP Launchpad (Süwag)",
        "HR_Portal_3311": "HR Portal (Süwag)",
        "Confluence_9100": "Confluence (Süwag)",
        "my_IT_order_6623": "my IT order",
        "BAT_Business_Activity_Tracker_7022": "BAT PL",
        "CTP_2407": "CTP PL",
        "BPM_OSD_PL_5209": "BPM OSD PL",
        "jflow_PL_6875": "jflow PL",
        "Qmatic_PL_CS_3195": "Qmatic PL CS",
        "Qmatic_PL_EN_3118": "Qmatic PL EN",
        "CCM_Inspire_7264": "CCM Inspire",
        "Atoss_artelisGruppe_und_VSEAgentur_3137": "Atoss artelis-Gruppe und VSE-Agentur",
        "Atoss_VSEGruppe_4374": "Atoss VSE-Gruppe",
        "AWS_Access_Portal_1318": "AWS Access Portal",
        "eDIVA_5372": "eDIVA",
        "G2G_VSEGruppe_6518": "G2G VSE-Gruppe",
        "AWS_Access_Portal_6740": "AWS Access Portal",
        "Qualys_Security_4331": "Qualys Security",
        "ODIN_FinOps_6411": "ODIN FinOps",
        "Cloudflare_4507": "Cloudflare",
        "ADP_TRAVEL_REISEMANAGEMENT_3368": "ADP TRAVEL REISEMANAGEMENT",
        "ITSicherheitsvorfall_melden_VSEGruppe_9292": "IT-Sicherheitsvorfall melden VSE-Gruppe",
        "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987": "HSE Sicherheitsvorfall melden VSE-Gruppe",
        "Speiseplan_VSEGruppe_3571": "Speiseplan VSE-Gruppe",
        "ITMeldebogen_VSEGruppe_1367": "IT-Meldebogen VSE-Gruppe",
        "LeanIX_5372": "LeanIX",
        "VSE_Wiki_CONFLUENCE_1902": "VSE Wiki CONFLUENCE",
        "Young_Talents_AzubiPortal_3338": "Young Talents Azubi-Portal",
        "Workday_Peakon_eNPS_1749": "Workday Peakon eNPS",
        "Umantis_0386": "Umantis",
        "Adeverinte_alte_aplicatii_HR_RO_CS_2447": "Bescheinigungen und weitere HR-Anwendungen (RO CS)",
        "Deconturi_card_companie_RO_CS_5333": "Abrechnungen mit der Firmenkarte (RO CS)",
        "Documente_delegatii_RO_CS_5332": "Unterlagen zu Dienstreisen (RO CS)",
        "SAP_ISU_CS_RO_8555": "SAP IS-U CS RO",
        "PKI_Semnatura_Digitala_6781hover": "Token zurücksetzen",
        "Users_Access_EER_9163hover": "RAPPS EER",
        "Evaluare_Personal_EER_2935hover": "Portal für Personalbewertung EER",
        "Sesizari_Administrare_Cladiri_EER_8543hover": "Portal für Meldungen zur Gebäudeverwaltung EER",
        "MRBS_EER_8445hover": "Besprechungsraum-Reservierung EER",
        "Delegatii_EER_1137hover": "Dienstreiseportal EER",
        "Users_Access_EER_5369hover": "Benutzerzugriffsformular EER",
        "Planificare_Concedii_EER_8588hover": "Urlaubsplanung EER",
        "Pontaje_si_Telemunca_EER_7087hover": "Zeiterfassung und Telearbeit EER",
        "BOT_6231hover": "Erstattung von Erholungs- und Behandlungstickets",
        "Bonusare_personal_6879hover": "Mitarbeiterbonus",
        "GRC_Request_5510hover": "GRC steht für Governance & Risk Compliance Access Control und ist ein SAP Workflow-Tool zur automatisierten Beantragung, Genehmigung und Zuweisung von Benutzerberechtigungen in SAP Systemen.",
        "iPEN_Portal_3047hover": "Die Information Plattform of Energy Networks – kurz iPEN – sorgt dafür, dass Daten regionaler Einheiten gebündelt und zentral zur Verfügung gestellt werden können. Bestehende und neu entwickelte intelligente Lösungen werden an die Plattform angebunden. Damit können sie kostengünstig, schnell und flexibel über die gesamte Netzgemeinschaft ausgerollt werden. Damit ist iPEN der zentrale Enabler für die Skalierung intelligenter Lösungen.",
        "YourVoiceEON_0693hover": "Die Plattform PEAKON versendet einmal pro Woche ca. 4 - 5 Fragen an dich, die sich mit Aspekten zu deinem Wohlbefinden und deiner aktuellen Arbeitssituation beschäftigen. Du kannst die Fragen bewerten (von 0-10), kommentieren oder auch überspringen. Die Beantwortung der wenigen Fragen dauert nur ca. 1 - 2 Minuten.",
        "ITPortal_5530hover": "Serviceportal der Süwag",
        "Transf4m_Ticket_Tool_6635hover": "Transf4m Ticket Tool",
        "Speedikon_C_1281hover": "Speedikon C",
        "Speiseplan_8904hover": "Menüplan",
        "Ariba_8690hover": "Einkaufsportal",
        "DiSch_20_0545hover": "das ist mein digitaler Schreibtisch",
        "ISMSMeldezentrale_9318hover": "ISMS-Meldezentrale",
        "SAP_Launchpad_8736hover": "SAP Launchpad",
        "HR_Portal_3311hover": "HR Portal",
        "Confluence_9100hover": "Confluence der Süwag",
        "my_IT_order_6623hover": "my IT order",
        "BAT_Business_Activity_Tracker_7022hover": "Zeiterfassung",
        "CTP_2407hover": "CTP (Zeit ist Geld)",
        "BPM_OSD_PL_5209hover": "BPM PP + CRM DSO",
        "jflow_PL_6875hover": "Unterstützung der Geschäftsprozessbearbeitung mit Jira",
        "Qmatic_PL_CS_3195hover": "Anwendung zur Verwaltung des Kundenflusses (Warteschlangen) im POS",
        "Qmatic_PL_EN_3118hover": "Anwendung zur Verwaltung des Kundenflusses (Warteschlangen) im POS",
        "CCM_Inspire_7264hover": "E.ONs zentralisierte Customer-Communication-Management-Plattform (CCM), betrieben mit Quadient Inspire, zur Erstellung und Bereitstellung von Kundenkommunikation.",
        "Atoss_artelisGruppe_und_VSEAgentur_3137hover": "Das ist unser Zeiterfassungssystem",
        "Atoss_VSEGruppe_4374hover": "Das ist unser Zeiterfassungssystem",
        "AWS_Access_Portal_1318hover": "Zugriff auf AWS-Accounts",
        "eDIVA_5372hover": "ANF-Benutzerverwaltung",
        "G2G_VSEGruppe_6518hover": "Gis System der VSE-Gruppe",
        "AWS_Access_Portal_6740hover": "Zugang zur AWA Cloud VSE-Gruppe",
        "Qualys_Security_4331hover": "Unternehmensweites Risikomonitoring",
        "ODIN_FinOps_6411hover": "ODIN FinOps VSE-Gruppe",
        "Cloudflare_4507hover": "Cloudflare VSE-Gruppe",
        "ADP_TRAVEL_REISEMANAGEMENT_3368hover": "ADP TRAVEL REISEMANAGEMENT  VSE-Gruppe",
        "ITSicherheitsvorfall_melden_VSEGruppe_9292hover": "IT-Sicherheitsvorfall melden VSE-Gruppe",
        "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987hover": "HSE Sicherheitsvorfall melden VSE-Gruppe",
        "Speiseplan_VSEGruppe_3571hover": "Speiseplan VSE-Gruppe",
        "ITMeldebogen_VSEGruppe_1367hover": "IT-Meldebogen VSE-Gruppe",
        "LeanIX_5372hover": "LeanIX",
        "VSE_Wiki_CONFLUENCE_1902hover": "Anleitungen",
        "Young_Talents_AzubiPortal_3338hover": "Young Talents Azubi-Portal VSE-Gruppe",
        "Workday_Peakon_eNPS_1749hover": "Workday Peakon eNPS",
        "Umantis_0386hover": "Umantis VSE-Gruppe",
        "Adeverinte_alte_aplicatii_HR_RO_CS_2447hover": "Diese Anwendung ermöglicht es allen Nutzern, verschiedene Arten von Bescheinigungen mit höchstens drei Klicks herunterzuladen. HR-Administratoren und Teamkoordinatoren können außerdem Bescheinigungen für die von ihnen betreuten Kollegen herunterladen. Mitarbeitende können zusätzlich ihre Betriebszugehörigkeit und Rentenunterstützung berechnen sowie weitere Dokumente bei der Personalabteilung anfordern.",
        "Deconturi_card_companie_RO_CS_5333hover": "Inhaber von Firmenkarten können über diese Anwendung einfach Spesenabrechnungen einreichen, ohne Belege per E-Mail oder Post zu senden oder Genehmigungen per E-Mail anzufordern. Der gesamte Prozess findet auf dieser Plattform statt.",
        "Documente_delegatii_RO_CS_5332hover": "Mit der Anwendung zur Verwaltung von Dienstreisen können Nutzer Dokumente zu ihren eigenen Reisen und denen ihrer Mitarbeitenden hinzufügen. HR-Administratoren können Dokumente gesammelt anzeigen, filtern und abschließen sowie weitere Unterlagen über automatisch versendete E-Mails anfordern.",
        "SAP_ISU_CS_RO_8555hover": "Der Service umfasst Tätigkeiten im Zusammenhang mit SAP-IS-U-x7G-Systemen, die von E.ON RO CS genutzt werden.",
        "subTitle": {
            "PKI_Semnatura_Digitala_6781SubTitle": "Token erneuern / zurücksetzen",
            "Users_Access_EER_9163subTitle": "RAPPS EER",
            "Evaluare_Personal_EER_2935subTitle": "Portal für Personalbewertung EER",
            "Sesizari_Administrare_Cladiri_EER_8543subTitle": "Portal für Meldungen zur Gebäudeverwaltung EER",
            "MRBS_EER_8445subTitle": "Besprechungsraum-Reservierung EER",
            "Delegatii_EER_1137subTitle": "Dienstreiseportal EER",
            "Users_Access_EER_5369subTitle": "Benutzerzugriffsformular EER",
            "Planificare_Concedii_EER_8588subTitle": "Urlaubsplanung EER",
            "Pontaje_si_Telemunca_EER_7087subTitle": "Zeiterfassung und Telearbeit EER",
            "BOT_6231subTitle": "Erstattung von Erholungs- und Behandlungstickets",
            "Bonusare_personal_6879subTitle": "Mitarbeiterbonus",
            "GRC_Request_5510SubTitle": "GRC Request",
            "iPEN_Portal_3047SubTitle": "Information Platform of Energy Networks",
            "YourVoiceEON_0693SubTitle": "YourVoice@E.ON",
            "ITPortal_5530SubTitle": "Süwag",
            "Transf4m_Ticket_Tool_6635SubTitle": "JIRA",
            "Speedikon_C_1281SubTitle": "Reservierung Arbeitsplätze",
            "Speiseplan_8904SubTitle": "Höchst",
            "Ariba_8690SubTitle": "Einkaufsportal",
            "DiSch_20_0545SubTitle": "Digitaler Schreibtisch",
            "ISMSMeldezentrale_9318SubTitle": "Süwag",
            "SAP_Launchpad_8736SubTitle": "WEB",
            "HR_Portal_3311SubTitle": "Selfservices",
            "Confluence_9100SubTitle": "Süwag",
            "my_IT_order_6623SubTitle": "E.ON",
            "BAT_Business_Activity_Tracker_7022SubTitle": "Geschäftsaktivitäts-Tracker",
            "CTP_2407SubTitle": "Czas to pieniądz",
            "BPM_OSD_PL_5209SubTitle": "BPM PP + CRM DSO",
            "jflow_PL_6875SubTitle": "Geschäftsprozessbearbeitung",
            "Qmatic_PL_CS_3195SubTitle": "Qmatic E.ON Polska",
            "Qmatic_PL_EN_3118SubTitle": "Qmatic Stoen Operator",
            "CCM_Inspire_7264SubTitle": "CCM - Plattform",
            "Atoss_artelisGruppe_und_VSEAgentur_3137SubTitle": "artelis-Gruppe und VSE-Agentur",
            "Atoss_VSEGruppe_4374SubTitle": "Atoss VSE-Gruppe",
            "AWS_Access_Portal_1318SubTitle": "IT - CloudCore",
            "eDIVA_5372SubTitle": "eDIVA ANF-Benutzerverwaltung -> eDIVA",
            "G2G_VSEGruppe_6518SubTitle": "G2G VSE-Gruppe",
            "AWS_Access_Portal_6740SubTitle": "AWS Access Portal VSE-Gruppe",
            "Qualys_Security_4331SubTitle": "Qualys Security VSE-Gruppe",
            "ODIN_FinOps_6411SubTitle": "ODIN FinOps VSE-Gruppe",
            "Cloudflare_4507SubTitle": "Cloudflare VSE-Gruppe",
            "ADP_TRAVEL_REISEMANAGEMENT_3368SubTitle": "ADP TRAVEL REISEMANAGEMENT  VSE-Gruppe",
            "ITSicherheitsvorfall_melden_VSEGruppe_9292SubTitle": "IT-Sicherheitsvorfall melden VSE-Gruppe",
            "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987SubTitle": "HSE Sicherheitsvorfall melden VSE-Gruppe",
            "Speiseplan_VSEGruppe_3571SubTitle": "Speiseplan VSE-Gruppe",
            "ITMeldebogen_VSEGruppe_1367SubTitle": "IT-Meldebogen VSE-Gruppe",
            "LeanIX_5372SubTitle": "LeanIX",
            "VSE_Wiki_CONFLUENCE_1902SubTitle": "VSE Wiki CONFLUENCE",
            "Young_Talents_AzubiPortal_3338SubTitle": "Young Talents Azubi-Portal VSE-Gruppe",
            "Workday_Peakon_eNPS_1749SubTitle": "Workday Peakon eNPS",
            "Umantis_0386SubTitle": "Umantis VSE-Gruppe",
            "Adeverinte_alte_aplicatii_HR_RO_CS_2447SubTitle": "Bescheinigungen und weitere HR-Anwendungen (RO CS)",
            "Deconturi_card_companie_RO_CS_5333SubTitle": "Abrechnungen mit der Firmenkarte (RO CS)",
            "Documente_delegatii_RO_CS_5332SubTitle": "Unterlagen zu Dienstreisen (RO CS)",
            "SAP_ISU_CS_RO_8555SubTitle": "SAP IS-U CS RO",
            "CFLPSubTitle": "Zentrales Fiori Launchpad",
            "corporateWorkspaceSubTitle": "SAP Build Work Zone, Advanced Edition",
            "SAPWebLaunchpadSubTitle": "Links zu SAP-Systemen",
            "timeSubTitle": "CATS",
            "meetingSubTitle": "GINGCO",
            "approvalSubTitle": "SNOW/SAP",
            "prSubTitle": "BANF",
            "praSubTitle": "BANF",
            "processingSubTitle": "SAP",
            "hrSubTitle": "MyHR",
            "concurSubTitle": "SAP Concur",
            "passwordSubTitle": "SAP Systems",
            "aribaSubTitle": "PO-Übersicht",
            "itresourcesSubTitle": "SNOW",
            "incidentSubTitle": "SNOW",
            "orderSubTitle": "Order IT Services",
            "myassetsSubTitle": "SNOW",
            "beelineSubTitle": "Externe Dienstleister",
            "prismaSubTitle": "HSE",
            "gertrudSubTitle": "Vorstandssitzungen vorbereiten",
            "notificationSubTitle": "Hausmeisterservice",
            "zukoSubTitle": "Umzüge durchführen",
            "eon_brandSubTitle": "it's on us",
            "pkiSubTitle": "Zertifikate verwalten",
            "mailSubTitle": "pflegen",
            "journeySubTitle": "FuV §37b EstG",
            "mygeniusSubTitle": "Digitale Lernplattform",
            "ideeonSubTitle": "Ideenmanagement",
            "ideenetSubTitle": "Ideenmanagement",
            "dpfSubTitle": "Digitale Personalakte",
            "corpsacSubTitle": "SAC",
            "corpportalSubTitle": "Corporate Portal",
            "redwoodSubTitle": "Redwood FA",
            "eamsap200SubTitle": "SAP Cloud Cockpits (200)",
            "eamsap100SubTitle": "SAP Cloud Cockpits (100)",
            "sodsapSubTitle": "SoD-Portal",
            "videonSubTitle": "VidEON",
            "alteryxSubTitle": "Alteryx",
            "ebamSubTitle": "EBAM",
            "egsSubTitle": "EGS",
            "epsnextSubTitle": "EPSnext",
            "fisquantumSubTitle": "FIS Quantum",
            "rmsSubTitle": "RMS",
            "slidoSubTitle": "Slido",
            "insightslibrarySubTitle": "Knowledge Repository",
            "getabstractSubTitle": "Online Bibliothek",
            "mypotentialSubTitle": "AMP",
            "dsesoftwareSubTitle": "DSE",
            "whistleblowingSubTitle": "E.ON Whistleblowing-Lösung",
            "maqsimaSubTitle": "Management von Gefährdungsbeurteilungen",
            "digitalrulebookSubTitle": "Konzernrichtlinien",
            "oneERPSubTitle": "EAM/ESM",
            "PerseusSubTitle": "Perseus",
            "cateringportalSubTitle": "Cateringportal",
            "westnetzregelwerkeSubTitle": "nScale",
            "werbemittelSubTitle": "Werbemittelshop",
            "westenergie_brandSubTitle": "Westenergie Frontify",
            "compassSubTitle": "Konzernweite interne Kommunikationsplattform",
            "gradarSubTitle": "Stellenbewertung und Vergütung",
            "beqomSubTitle": "beqom",
            "kycSubTitle": "Compliance Counterparty Check",
            "talentrySubTitle": "Job Empfehlungsprogramm",
            "samSubTitle": "Sicherheitstraining @E.ON",
            "enormSubTitle": "Compliance-Monitor",
            "redonlineSubTitle": "red-on-line",
            "tagetikcpmSubTitle": "CPM",
            "tagetikcpmermSubTitle": "CPM and ERM",
            "smartguideSubTitle": "Smart Guide Hub (Buchhaltungs-Wiki)",
            "tagetiksacSubTitle": "Tagetik SAP Analytics Cloud",
            "servicehubSubTitle": "Service Hub",
            "myitSubTitle": "IT-Support und Neuigkeiten",
            "SailPointSubTitle": "Identity & Access Management Overview",
            "P29SubTitle": "SAP EIC",
            "P83SubTitle": "SAP P83",
            "BICSubTitle": "BIC Cloud",
            "CelonisSubTitle": "Proces Mining",
            "CarsyncSubTitle": "Fuhrparkmanagement",
            "ISUSpaceSubTitle": "Arbeitsplatz- und Raumverwaltung",
            "GNISSubTitle": "EDI-Stammdatenmanagement",
            "ecount_EDISubTitle": "EDI-Datenmanagement",
            "SAP_Datasphere_EDISubTitle": "Datenintegration & Business Data Fabric",
            "ukhrSubTitle": "UK HR App"
        }
    },
    "chatBot": {
        "contactNumberPlaceholder": "Kontakt Nummer mit Country Code",
        "incidentDetailsLabel": "Zusammenfassung des Vorfalls",
        "contactNumberLabel": "Bitte geben Sie Ihre bevorzugte Telefonnummer ein.",
        "searchBack": "zurück zur vorherigen Seite",
        "sourceName": "Quelle",
        "welcomeMessage": "Chat-Eingabeaufforderung",
        "chatbotPlaceholder": "Geben Sie hier ein...",
        "sendbtn": "schicken",
        "cancelBtn": "Rückruf abbrechen",
        "showMore": "Mehr anzeigen",
        "showMoreTooltip": "Vollständige Antwort anzeigen",
        "showLess": "Weniger anzeigen",
        "showLessTooltip": "Vollständige Antwort minimieren",
        "continueAssistance": "Mit dem Assistenten fortfahren",
        "continueAssistanceTooltip": "Mit dem Assistenten fortfahren, um weitere Fragen zu stellen",
        "askMe": "Stellen Sie Ihre Fragen",
        "feedbackTitle": "War das hilfreich?",
        "feedbackThumbsUpLabel": "Ja, das hat geholfen",
        "feedbackThumbsDownLabel": "Brauchst du weitere Hilfe?",
        "feedbackPrompt": "Hier kannst du Feedback teilen",
        "feedbackMsg": "Vielen Dank für Ihr Feedback! Wir schätzen Ihre Hilfe bei der Verbesserung unserer Dienstleistungen.",
        "imageUpload": "Bild hochladen",
        "uploadImageTooltip": "Bild hochladen und Frage stellen.",
        "uploadImageFormat": "Unterstütztes Format: JPG/PNG",
        "uploadImageProcessing": "Bild wird verarbeitet...",
        "uploadImageQuestions": "Fragenvorschläge:",
        "card": {
            "selfService": "Selbstbedienung",
            "efficiency": "Effizienz",
            "ngService": "Service der nächsten Generation"
        },
        "disclaimerText": "Die Hilfe kann Inhalte erzeugen, die ungenau und fehlerhaft sind. Prüfen Sie wichtige Informationen.",
        "selfServiceTitle": "IT Support",
        "selfServiceContent": "KI-gestützte Self-Service-Unterstützung für die Lösung von Swift-Service-Fällen",
        "knowledgeBaseTitle": "Knowledge Base",
        "knowledgeBaseContent": "Bessere Mitarbeitererfahrung durch Information",
        "internetSearchTitle": "General Questions",
        "wentWell": "Was ist gut gelaufen? (optional)",
        "wentWrong": "Was hat nicht so gut geklappt?",
        "privacyMsg": "Wir respektieren deine Privatsphäre und versichern dir, dass deine Rückmeldung vertraulich behandelt wird",
        "appreciateService": "Wir schätzen deine Hilfe bei der Verbesserung unserer Services",
        "feedbackMessage": "Danke für dein Feedback!",
        "relevantSearches": "Relevanteste Suchanfragen",
        "aiAssitanceSuggestion": "Du können Ihre Fragen an AI Assistance stellen, indem Du das folgende Eingabefeld verwenden",
        "aiActionMsg": "Ihr interner Speicher scheint voll zu sein. Ich kann Ihnen helfen, das Installationsproblem zu beheben, indem ich Ihre temporären Dateien automatisch säubere und Ihren Papierkorb leere. Möchten Sie, dass ich automatisch säubere?",
        "aiActionPrimaryBtn": "automatisch bereinigen",
        "aiActionSecondaryBtn": "nicht automatisch bereinigen",
        "aiActionSuccess": "Ihr Speicher wurde bereinigt.",
        "aiActionFailed": "Etwas ist schiefgelaufen. Bitte versuchen Sie es später noch einmal. Oder versuchen Sie es bitte manuell.",
        "hey": "Hallo",
        "topicStartMessage": "bei welchem IT-Anliegen kann ich dir heute helfen?",
        "newChat": "Neuer Chat",
        "search": "E.ON Search",
        "open": "Öffnen",
        "close": "Schließen",
        "recentChats": "Letzte Chats",
        "ask": "Frag",
        "internet": "Internet",
        "askEon": "E.ON Fragen",
        "askInternet": "Internet Fragen",
        "askFollowUpQuestion": "Stell eine weitere Frage",
        "resolveIssue": "Das Teilen von Feedback ermöglicht Supportmaßnahmen",
        "resolveIssueAfterFeedback": "Es tut mir leid, dass ich dein Anliegen nicht lösen konnte. Wie kann ich dir weiterhelfen?",
        "differentiator": "oder",
        "incident": "Raise Service ticket",
        "creatingIncident": "Erstellen einer Störung",
        "liveAgent": "Chat with an agent",
        "requestCallbackBtn": "Request Callback",
        "ticketDescription": "Ticketbeschreibung auf der Grundlage der jüngsten Diskussion",
        "createIncident": "Vorfall erstellen",
        "confirmCreateIncident": "Bearbeiten und Erstellen einer Störung",
        "editCreateIncident": "Störung bearbeiten und erstellen",
        "ticketSuccessMsg": "Ihre Störung wurde erfolgreich erstellt, Ticket-Nummer: ",
        "ticketErrorMsg": "Etwas ist schiefgelaufen. Bitte versuche es später noch einmal.",
        "chatBotTitle": "Nutze den MyHelp Assistenten, um Fragen zu stellen sowie Unterstützung und hilfreiche Informationen zu erhalten- sowohl von Internen, als auch externen Quellen",
        "duplicateError": "Doppelte Frage, bitte stellen Sie eine andere Frage",
        "content": "Inhalt",
        "tone": "Ton",
        "information": "Informationen",
        "complete": "Vollständig",
        "other": "Anderes",
        "irelevantContent": "Irrelevanter Inhalt",
        "lackOfDetail": "Fehlen von Details",
        "incorrectInformation": "Falsche Informationen",
        "copyLink": "Link kopieren",
        "openLink": "Link öffnen",
        "internetSearchContent": "Basierend auf Fragen Sie mich etwas EON gpt",
        "assignmentGroupForTicket": "eon-de-gsd",
        "copy": "Kopieren",
        "share": "Teilen",
        "copiedMsg": "Erfolgreich kopiert",
        "copyLinkMsg": "Link kopieren",
        "sharableLink": "Teilen Link",
        "uploadImage": "Bild hochladen und Frage stellen",
        "liveAgentChat": {
            "connectWithLiveAgent": "Verbindung mit dem my IT support",
            "connectingWithLiveAgent": "Wir verbinden dich mit dem my IT support....",
            "connectingHint": "Du kannst zum Assistenten zurückkehren, indem du auf den Link unter dem Chat -Feld klickst",
            "switchToAssistance": "Beenden Sie den Chat und wechseln Sie zur Unterstützung",
            "agentLeftMsg": "Danke, das du E.ON kontaktiert hast",
            "typeMessageHint": "Geben Sie Ihre Nachricht hier ein...",
            "disconnectingMsg": "Beenden des Chats und Wechseln zum Assistenten",
            "continue": "Fortsetzen",
            "exitChat": "Chat beenden",
            "chatSessionEndPrompt": "Chat-Sitzung wird automatisch in <timer> beendet"
        },
        "requestCallback": {
            "languageConfirmation": "Der MyHelp Assistent hat erkannt, dass deine Standardsprache “<language>” ist. Bestätige die Auswahl, um mit einem Agenten verbunden zu werden, oder ändere unten die gewünschte Sprache und den Agententyp.",
            "channelsText": "Rückruf erhalten über",
            "languageText": "Kommunikationssprache",
            "channelLabel": "Kanal auswählen",
            "phoneLabel": "Verbinde mich über",
            "languageLabel": "Sprache auswählen",
            "tryAgain": "Erneut versuchen",
            "technicalIssue": "Dein Rückruf konnte aufgrund eines technischen Problems nicht abgeschlossen werden. Bitte versuche es erneut.",
            "addNewNumber": "neue Nummer",
            "availableMobileNumbers": "verfügbare Handynummern",
            "chosenNumber": "Kontaktiere mich über diese Nummerr",
            "phoneError": "Bitte gib eine gültige Kontaktnummer ein",
            "referenceNumber": "Referenznummer",
            "tooltip": {
                "confirmBtn": "Bestätigen, um einen Rückruf anzufordern",
                "resetBtn": "Formular zurücksetzen, um alle Auswahlen zu löschen und neu zu beginnen",
                "cancelBtn": "Rückruf abbrechen"
            },
            "newNumber": "Neue Nummer"
        },
        "quickActions": {
            "heading": "my IT support",
            "actions": {
                "createIncident": "Ticket erstellen",
                "chatWithServiceDesk": "Live Chat starten",
                "requestCallback": "Rückruf anfordern",
                "ongoingConversation": "Ja, das ist Bestandteil meines letzten Gesprächs.",
                "newConversation": "Nein. Ich brauche Hilfe bei der Lösung eines neuen Problems.",
                "confirmAndCreateTicket": "Bestätigen und Ticket erstellen",
                "cancelTicketCreation": "Ticket-Erstellung abbrechen",
                "confirmChatWithServiceDesk": "Bestätigen und verbinden mit dem my IT support",
                "cancelChatWithServiceDesk": "Chat mit my IT support abbrechen",
                "cancelRequestCallback": "Rückrufanforderung abbrechen",
                "confirmRequestCallback": "Herstellung der Verbindung per <channel> <phone> mit einem Agenten des my IT support in <language> Sprache"
            },
            "state": {
                "whatsTheIssue": "Was ist das Problem, das du lösen willst?",
                "lastConversation": "Natürlich, ist das Problem Teil der letzten Unterhaltung?",
                "createIncidentLabel": "Du bist dabei, ein Ticket für eine Störung zu erstellen",
                "cancelAck": "Notiert. Kann ich dir bei einem anderen Problem helfen?",
                "chatWithServiceDeskLabel": "Du bist dabei, dich mit einem my IT support Agenten zu verbinden",
                "createTicketLabel": "Bestätigen und Ticket erstellen",
                "cancelTicketLabel": "Ticket-Erstellung abbrechen",
                "creatingIncidentTicket": "Störungsticket erstellen",
                "ticketAttachment": "Bitte fügen Sie einen Screenshot des Fehlers oder Problems hinzu.",
                "ticketAttachmentTooltipInstruction": "Drücken Sie die Windows-Logo-Taste + Druck oder verwenden Sie das Snipping-Tool, um einen Bildausschnitt zu erfassen.",
                "ticketAttachmentTooltipWarning": "Bildgröße muss kleiner als 5 MB sein.",
                "ticketAttachmentLabel": "Screenshot anhängen",
                "ticketAttachmentTitle": "Angefügter Screenshot für Ticket",
                "ticketAttachmentError": "Die ausgewählte Datei kann nicht angehängt werden. Stelle sicher, dass die Datei kleiner als 5 MB ist",
                "ticketAttachmentErrorAction": "Versuche es erneut.",
                "ticketDescription": "Ticket Beschreibung",
                "ticketNonITWarning": "Die Unterstützung konnte keine Schlüsselwörter finden, um Ihr Problem als IT-bezogen zu identifizieren.",
                "ticketNonITWarningQuestion": "Möchten Sie basierend auf Ihrem Gespräch über ein Incident beim my IT support erstellen?",
                "ticketNonITWarningRecommendationLabel": "Empfehlung:",
                "ticketNonITWarningRecommendationText": "Wenn Sie ein Problem haben, das nicht mit Software oder Hardware zusammenhängt, können Sie versuchen, Ihre Suche umzuformulieren oder unten eine Folgefrage zu stellen.",
                "connectWithServiceDeskLabel": "Bestätige den Chat mit dem my IT support",
                "requestCallbackLabel": "Rückruf anfordern",
                "requestCallbackInQueuePhone": "Ihre Rückrufanfrage wurde übermittelt. Sie werden in etwa 5 Minuten unter <strong><phone></strong> kontaktiert. Währenddessen können Sie gerne andere Anwendungen weiter nutzen.",
                "requestCallbackInQueueTeams": "Ihre Rückrufanfrage wurde übermittelt. Sie werden in etwa 5 Minuten über <strong>Microsoft Teams</strong> kontaktiert. Währenddessen können Sie gerne andere Anwendungen weiter nutzen.",
                "requestCallbackFailed": "Wir konnten deinen Rückruf aufgrund eines technischen Problems nicht abschließen. Bitte versuchen es erneut.",
                "requestCallbackPromptAnswer": "Du bist dabei, einen Rückruf vom my IT support anzufordern",
                "requestCallbackConfirmLabel": "Bestätige, um einen Rückruf anzufordern"
            },
            "tooltips": {
                "createIncident": "Unterstützt dich bei der Lösung eines IT Problems und erstellt bei Bedarf ein Ticket beim my IT support",
                "chatWithServiceDesk": "Unterstützt dich bei der Lösung eines IT Problems und kontaktiert bei Bedarf das my IT support via Chat",
                "requestCallback": "Rückruf vom my IT support anfordern"
            }
        },
        "askTooltip": {
            "eon": "Erhalte unternehmensspezifische Informationen aus internen Quellen",
            "internet": "Erhalte Informationen von internen und externen Quellen wie E.ON GPT"
        },
        "jiraIntegration": {
            "viewInJira": "Zeige es in Jira",
            "responseHeading": "Hier findest du die Zusammenfassung deiner Jira Tickets:",
            "responseSubheading": "Hier sind deine Top-15 Anfragen",
            "noResponse": "Offenbar sind für Ihre Anfrage derzeit keine JIRA-Tickets verfügbar.",
            "supportedQuestionMsg": "Hey, I am sorry. I didn't quite understand your question. Can you please rephrase it again. I am sharing some sample questions to assist you:"
        },
        "intune": {
            "selectDevice": "Gerät auswählen",
            "changeBrowserHomePage": "Browser-Startseite ändern",
            "fixWillBeApplied": "Die Korrektur wird auf diesem System angewendet",
            "confirm": "Bestätigen",
            "fixThis": "Beheben",
            "enterDeviceName": "Gerätename eingeben",
            "selectOrEnterDevice": "Bitte wähle ein Gerät aus oder gib den Namen deines Geräts ein.",
            "actionFailed": "Aktion fehlgeschlagen.",
            "working": "In Bearbeitung...",
            "fixOnThis": "Auf diesem Gerät anwenden",
            "deviceLabel": "Gerät",
            "lastActive": "Zuletzt aktiv",
            "today": "Heute",
            "yesterday": "Gestern",
            "daysAgo": "Tage her",
            "deviceTypeLaptop": "Laptop",
            "deviceTypeDesktop": "Desktop",
            "deviceTypeVirtualMachine": "Virtuelle Maschine",
            "deviceTypeUnknown": "Gerät",
            "homepageBrowserChange": {
                "syncInstructions": "Die Änderung wird jetzt auf Ihr Gerät angewendet. Dies kann etwa 30 Minuten dauern. Wenn Sie den Vorgang beschleunigen möchten, können Sie eine manuelle Synchronisierung im Company Portal starten:\n1. Öffnen Sie Company Portal\n2. Klicken Sie unten links neben dem Zahnradsymbol auf Settings.\n3. Klicken Sie dann auf die blaue Schaltfläche \"Synchronize\" und warten Sie, bis die Synchronisierung abgeschlossen ist.",
                "changeHomepageInstructions": "1. Klicke oben rechts auf die drei Punkte (…).\n2. Wähle „Einstellungen“.\n3. Wähle im linken Menü „Start-, Startseite und neue Registrierkarte“ aus.\n4. Stelle im Menüpunkt „Beim Start“ sicher, dass „Benutzerdefinierte Websites öffnen“ aktiviert ist.\n5. Klicke auf „Website hinzufügen“.\n6. Gib die Web-Adresse ein, die du als neue Startseite in Microsoft Edge festlegen möchtest (zum Beispiel: https://compass.eon.com/).\n7. Klicke auf „hinzufügen“.\n\nWenn du eine Website aus der Startseiten-Liste entfernen möchtest, klicke auf die drei Punkte (…) neben der Website und wähle „Löschen“ aus.",
                "policyDescription": "Deine Organisation verwaltet die Einstellungen der Browser-Startseite derzeit über Geräterichtlinien. Um die Änderung der Startseite zu ermöglichen, müssen wir zunächst feststellen, welches Gerät das Richtlinienupdate erhalten soll.",
                "deviceSelectedForPolicy": "ausgewählt für die Freischaltung der Startseiten-Richtlinie",
                "stepsForEdge": "Schritte zum Ändern der Startseite in Microsoft Edge",
                "whatsNextTitle": "Wie geht es weiter?",
                "whatsNextSubmitted": "Eine Anfrage zur Zulassung einer anpassbaren Startseite wurde an die Geräterichtlinien-Warteschlange gesendet.",
                "whatsNextSyncTime": "<strong>30 Minuten</strong> durchschnittliche Synchronisierungszeit für die Aktualisierung der Hintergrundrichtlinie erforderlich.",
                "whatsNextReturn": "Bitte kehren Sie nach 30 Minuten zu Ihren Browsereinstellungen zurück und führen Sie die folgenden Schritte aus.",
                "homepageEnabled": "Du kannst jetzt die Startseite deines Browsers ändern. Bitte beachte, dass die Änderung möglicherweise nicht sofort wirksam wird. Warte etwa 30 Minuten, bis die Synchronisierung abgeschlossen ist, und schließe dann Edge und öffne es erneut.",
                "homepageAlreadyEnabled": "Dein Gerät hat die Änderung der Startseite bereits aktiviert. Gehe zu den Browsereinstellungen und versuche es erneut.",
                "homepageEnableFailed": "Ich konnte die Änderung der Startseite gerade nicht aktivieren. Bitte versuche es später erneut.",
                "homepageRemoved": "Gerät aus der Startseiten-Richtlinieentfernt."
            }
        },
        "nexthinkIntegration": {
            "failureMsg": "Hoppla! Etwas ist schief gelaufen. Bitte versuchen Sie es später noch einmal. Wenn das Problem weiterhin besteht, melden Sie bitte ein Problem über die Schnellaktionen",
            "assistanceTask": "Assistent Aufgaben",
            "myActions": "Meine Aktionen",
            "itReportTitle": "Hier ist die Übersicht deiner Energie-Effizienz",
            "days": "Tage",
            "device": "Geräte",
            "sinceRestarted": "Seit Neustart",
            "deviceRestartRecommendation": "Sofortiger Neustart des Gerätes wird empfohlen",
            "deviceInCompliance": "Dein Gerät ist compliant",
            "energyConsumed": "Energiekonsum während der letzten sieben Tage",
            "coEmitted": "CO2 Ausstoß während der letzten sieben Tage",
            "cacheActionMsg": "Bitte starte deinen Browser neu, damit die Änderungen wirksam werden.",
            "diskClean": {
                "primaryBtn": "Ja, Laufwerk jetzt säubern",
                "secondaryBtn": "Nein, Laufwerk jetzt nicht säubern",
                "successMsg": "Dein Laufwerk wurde erfolgreich bereinigt",
                "successMsgOnList": "Dein Laufwerk wurde erfolgreich bereinigt",
                "failureMsg": "Dein Laufwerk konnte nicht gesäubert werden",
                "progressMsg": "Laufwerk wird gesäubert",
                "disclaimer": "Bitte beachte, dass wir deine persönlichen oder beruflichen Daten nicht anrühren werden. Während die Bereinigung im Hintergrund stattfindet, kannst du gerne weiterhin den Assistenten nutzen.",
                "acknowledgeQuery": "Ich kann eine Datenträgerbereinigung für Sie durchführen. Während der Datenträgerbereinigung werden unnötige Dateien, Caches oder alte Protokolle auf Ihrem System bereinigt. Bitte klicken Sie auf die Schaltfläche unten, um fortzufahren."
            },
            "chromeCache": {
                "primaryBtn": "Ja, leere den Chrome Cache",
                "secondaryBtn": "Nein, leere den Chrome Cache nicht",
                "successMsg": "Dein Chrome Cache wurde erfolgreich geleert. Bitte starte deinen Browser neu, damit die Änderungen wirksam werden.",
                "successMsgOnList": "Dein Chrome Cache wurde erfolgreich geleert",
                "failureMsg": "Dein Chrome Cache konnte nicht gesäubert werden",
                "progressMsg": "Chrome Cache wird geleert",
                "disclaimer": "Bitte beachte, dass wir deine persönlichen oder beruflichen Daten nicht anrühren werden. Während die Bereinigung im Hintergrund stattfindet, kannst du gerne weiterhin den Assistenten nutzen.",
                "acknowledgeQuery": "Ich kann Ihnen helfen, den Browser-Cache zu leeren. Bitte klicken Sie auf die Schaltfläche unten, um fortzufahren."
            },
            "edgeCache": {
                "primaryBtn": "Ja, leere den Edge Cache",
                "secondaryBtn": "Nein, leere den Edge Cache nicht",
                "successMsg": "Dein Edge Cache wurde erfolgreich geleert. Bitte starte deinen Browser neu, damit die Änderungen wirksam werden.",
                "successMsgOnList": "Dein Edge Cache wurde erfolgreich geleert",
                "failureMsg": "Dein Edge Cache konnte nicht gesäubert werden",
                "progressMsg": "Edge Cache wird geleert",
                "disclaimer": "Bitte beachte, dass wir deine persönlichen oder beruflichen Daten nicht anrühren werden. Während die Bereinigung im Hintergrund stattfindet, kannst du gerne weiterhin den Assistenten nutzen.",
                "acknowledgeQuery": "Ich kann Ihnen helfen, den Browser-Cache zu leeren. Bitte klicken Sie auf die Schaltfläche unten, um fortzufahren."
            },
            "empowerApp": {
                "primaryBtn": "Ja, Reparatur jetzt ausführen",
                "secondaryBtn": "Nein, Reparatur  jetzt nicht ausführen",
                "successMsg": "Dein Empower Plugin wurde erfolgreich repariert",
                "successMsgOnList": "Dein Empower Plugin wurde erfolgreich repariert",
                "failureMsg": "Dein Empower Plugin konnte nicht repariert werden",
                "progressMsg": "Automatische Reparatur wird ausgeführt",
                "disclaimer": "Das Empower Plugin wird jetzt neu installiert. Bitte schließe all deine M365 Apps, bevor du fortfährst.",
                "acknowledgeQuery": "Ich kann Ihnen bei Problemen mit dem Empower-Add-In helfen. Bitte klicken Sie unten, um das Empower-Plugin zu reparieren."
            },
            "teamsCache": {
                "primaryBtn": "Ja, säubere den Teams Cache",
                "secondaryBtn": "Säubere den Teams Cache nicht",
                "successMsg": "Dein Teams-Cache wurde gelöscht. Du kannst Teams öffnen und alle Einstellungen, die zurückgesetzt wurden, wieder anpassen.",
                "successMsgOnList": "Dein Teams Cache wurde gesäubert",
                "failureMsg": "Dein Teams Cache konnte nicht gesäubert werden",
                "progressMsg": "Teams Cache wird gelöscht",
                "disclaimer": "Deine persönlichen oder arbeits Daten bleiben unangetastet. Während des Vorgangs kannst du weiterhin den Assistenten nutzen.",
                "acknowledgeQuery": "Ich kann Ihnen helfen, den Teams-Cache zu leeren. Bitte klicken Sie auf die Schaltfläche unten, um fortzufahren."
            },
            "teamsReinstall": {
                "primaryBtn": "Ja, installiere Teams neu",
                "secondaryBtn": "Nein, installiere Teams nicht neu",
                "successMsg": "Die neu-Installation von Teams ist abgeschlossen.",
                "successMsgOnList": "Die neu-Installation von Teams ist abgeschlossen.",
                "failureMsg": "Die neu-Installation von Teams konnte nicht abgeschlossen werden",
                "progressMsg": "Teams wird neu installiert",
                "disclaimer": "Bitte beachte, dass deine Teams App gleichzeitig heruntergeladen und neu installiert wird. Dadurch wird die Teams App neu gestartet. Bitte speichere deine Arbeit, bevor du fortfährst.",
                "acknowledgeQuery": "Die Neuinstallation der Microsoft Teams-App könnte das Problem beheben. Bitte klicken Sie auf die Schaltfläche unten, um fortzufahren."
            },
            "outlookOst": {
                "primaryBtn": "Ja, Outlook reparieren",
                "secondaryBtn": "Outlook nicht reparieren",
                "successMsg": "Outlook-Profil neu erstellt",
                "successMsgOnList": "Outlook-Profil neu erstellt",
                "failureMsg": "Das Outlook-Profil konnte nicht neu erstellt werden",
                "progressMsg": "Outlook-Profil wird neu erstellt",
                "disclaimer": "Durch das Ausführen dieser Aktion wird dein Outlook-Profil lokal neu erstellt. Dadurch wird der Download von E-Mails aus Office Exchange gestartet. Stelle bitte sicher, dass ausreichend Netzwerkbandbreite und Speicherplatz verfügbar sind.",
                "acknowledgeQuery": "Dies könnte auf Verbindungsprobleme oder veraltete Einstellungen zurückzuführen sein. Ich kann Ihnen bei der Fehlerbehebung helfen und Ihr Outlook wieder synchronisieren."
            },
            "repairOfficeApps": {
                "primaryBtn": "Ja, Office-Anwendungen reparieren",
                "secondaryBtn": "Office-Anwendungen nicht reparieren",
                "successMsg": "Office-Anwendungen repariert",
                "successMsgOnList": "Office-Anwendungen repariert",
                "failureMsg": "Office-Anwendungen konnten nicht repariert werden",
                "progressMsg": "Office-Anwendungen werden neu installiert",
                "disclaimer": "Durch das Ausführen dieser Aktion werden Office-Anwendungen neu installiert. Gleichzeitig wird versucht, sie zu reparieren. Speichere bitte alle nicht gespeicherten Arbeiten, bevor du fortfährst.",
                "acknowledgeQuery": "Dies könnte auf eine beschädigte Installation oder ein Kompatibilitätsproblem zurückzuführen sein. Ich kann Ihnen helfen, Office-Apps zu reparieren, damit Ihre Apps reibungslos geöffnet werden."
            },
            "intuneSync": {
                "primaryBtn": "Ja, Intune-Synchronisierung starten",
                "secondaryBtn": "Synchronisierung nicht starten",
                "successMsg": "Intune-Synchronisierung abgeschlossen",
                "successMsgOnList": "Intune-Synchronisierung abgeschlossen",
                "failureMsg": "Intune-Synchronisierung konnte nicht gestartet werden",
                "progressMsg": "Intune-Synchronisierung läuft",
                "disclaimer": "Bitte beachte, dass diese Aktion lediglich die Intune-Synchronisierungsdienste neu startet und nicht zu einer Neuinstallation oder Reparatur von Intune (Unternehmensportal) führt.",
                "acknowledgeQuery": "Ich kann Ihnen helfen, den Status Ihres Geräts zu aktualisieren und es mit Intune zu synchronisieren, um sicherzustellen, dass es konform ist, auf dem neuesten Stand ist und die neuesten Richtlinien anwendet."
            },
            "teamsAddin": {
                "primaryBtn": "Ja, MS Teams-Add-In aktivieren",
                "secondaryBtn": "Nein, MS Teams-Add-In nicht aktivieren",
                "successMsg": "Die Reparatur des MS Teams-Add-Ins ist abgeschlossen",
                "successMsgOnList": "Die Reparatur des MS Teams-Add-Ins ist abgeschlossen",
                "failureMsg": "Das MS Teams-Add-in konnte nicht aktiviert werden",
                "progressMsg": "MS Teams-Add-In wird aktiviert",
                "disclaimer": "Bitte beachte, dass für die Reparatur des MS Teams-Add-Ins ein Neustart von Outlook erforderlich ist. Sichere bitte alle Deine Dateien, bevor Du fortfährst.",
                "acknowledgeQuery": "Ich kann das Teams-Add-In in Outlook wiederherstellen, damit Sie wieder Besprechungen planen können. Bitte klicken Sie auf die Schaltfläche unten, um fortzufahren."
            },
            "windowsUpdate": {
                "primaryBtn": "Ja, auf Updates überprüfen",
                "secondaryBtn": "Nein, nicht auf Updates überprüfen",
                "successMsg": "Windows Update wurde ausgelöst",
                "successMsgOnList": "Windows Update wurde ausgelöst",
                "failureMsg": "Windows Update kann nicht ausgelöst werden",
                "progressMsg": "Auf Updates überprüfen",
                "disclaimer": "Diese Aktion dient dazu, Updates von Microsoft zu überprüfen und herunterzuladen. Bitte stelle sicher, dass Du mit einem geeigneten Netzwerk verbunden bist, um alle Updates herunterzuladen.",
                "acknowledgeQuery": "Ich kann Sie bei der Behebung von Windows-Update- und Compliance-Problemen auf Ihrem Gerät unterstützen. Bitte klicken Sie auf die Schaltfläche unten, um fortzufahren"
            },
            "smartSolution": {
                "systemName": "System Name",
                "primaryBtn": "Healthcheck durchführen",
                "secondaryBtn": "Nicht jetzt",
                "askToRunHealthCheck": "Möchtest du, dass der Assistent einen Health-Check durchführt?",
                "healthCheckApiRunning": "Analyse und Ausführung des Health-Checks",
                "healthCheckApiFail": "Das Laden der für den Health-Check benötigten Informationen war nicht erfolgreich. Bitte versuche es noch einmal",
                "healthCheckApiSuccess": "Ich habe dein System analysiert. Die folgenden Probleme bestehen:",
                "systemCheckMsg": "Systemprüfung läuft",
                "systemCheckMessages": {
                    "recentlyStarted": "System ist auf dem neuesten Stand und wurde kürzlich neu gestartet",
                    "appsHealthy": "Alle App-Installationen sind funktionsfähig",
                    "driveSpace": "Auf dem Systemlaufwerk ist ausreichend freier Speicher vorhanden",
                    "noCrashes": "Keine Anwendungsabstürze in letzter Zeit erkannt"
                },
                "healthCheckNoIssue": "Ich habe das System analysiert. <b>Alles scheint ordnungsgemäß zu funktionieren.</b>",
                "recommendedActionHeading": "Empfohlene Aktionen",
                "askForElaboration": "Du kannst das spezifiesche Problem auch näher erläutern oder einen Screenshot des Problems hochladen.",
                "remindForSystemCheck": "Okay, lasse mich einfach wissen, wenn du einen Systemcheck durchführen möchtest.",
                "recommendedFixesHeading": "Empfohlene Korrekturen",
                "recommendedActionInfo": "Wähle die vorgeschlagenen Möglichkeiten aus oder ab, falls notwendig",
                "noRecommendedAction": "Keine vorgeschlagenene Maßnamen verfügbar",
                "initiateActionsButton": "Starte Reparatur",
                "selectedActionsProgress": "Ausgewählte Maßnamen verden bearbeitet.",
                "selectedActionsProgressNote": "Bitte zögere nicht den Assistenten zu verwenden, während die Aktion ausgeführt wird. Die Aktion wurde der Aufgabenkarte hinzugefügt und du kannst dich über den Fortschritt informieren. Du bekommst Bescheid, wenn die Aktion ausgeführt wurde.",
                "selectedActionsCompleted": "Die ausgewählten Aktionen wurden erfolgreich ausgeführt.",
                "selectedActionsFailed": "Die ausgewählten Aktionen waren nicht erfolgreich. Überprüfe für weitere Details bitte die Aufgabenkarte.",
                "selectedActionsPartiallyCompleted": "Die ausgewählten Aktionen waren teilweise erfolgreich. Überprüfe für weitere Details bitte die Aufgabenkarte.",
                "myActionDone": "Als erledigt markieren",
                "manualActionDisclaimer": "Dieser Prozess umfasst sowohl automatisierte als auch manuelle Schritte. Bitte führe die Aktionen aus, wenn du dazu aufgefordert wirst",
                "manualActionNotification": "TUm die Korrektur abzuschließen, führe bitte die unter „Meine Aktionen” aufgeführten zusätzlichen Schritte manuell aus.",
                "deviceSelectionHeading": "Ich habe gesehen, dass du mehrere Systeme verwendest. Wenn du die folgende Aktion auf einem anderen System ausführen möchtest, wähle bitte aus der folgenden Liste aus.",
                "deviceSelectionLabel": "Wählen das System für die Nexthink-Aktion aus",
                "alerts": {
                    "successTitle": "Aktion ausgeführt!",
                    "successMessage": "Die ausgewählten Maßnamen wurden erfolgreich ausgeführt.",
                    "errorTitle": "Aktion gescheitert!",
                    "errorMessage": "Bei der Ausführung der ausgewählten Aktion ist es zu einem Fehler gekommen.",
                    "partialTitle": "Aktion teilweise ausgeführt",
                    "partialMessage": "Die ausgewählten Maßnamen wurden teilweise ausgeführt. Überprüfe für weitere Details bitte die Aufgabenkarte."
                },
                "reportAndAction": {
                    "systemCrashes": {
                        "message": "In den letzten 7 Tagen sind auf deinem Gerät <n> Bluescreens aufgetreten.",
                        "action": "Bitte kontaktiere das GSD für weitere Hilfe",
                        "actionInfo": "(Keine Aktion) Bitte kontaktiere das GSD für weitere Unterstützung"
                    },
                    "edgeCrashes": {
                        "message": "Wir haben Hinweise auf <n> Abstürze im Zusammenhang mit dem Edge-Browser in den letzten 7 Tagen gefunden. Wir werden versuchen, dieses Problem durch Ausführen eines Skripts auf deinem Computer zu beheben.",
                        "action": "Säubere den Edge Browser Cache",
                        "actionInfo": "Hierdurch wird der Edge Browser Cache gesäubert. Es werden keine persönlichen Dateien modifiziert."
                    },
                    "chromeCrashes": {
                        "message": "Wir haben Hinweise auf <n> Abstürze im Zusammenhang mit dem Chrome-Browser in den letzten 7 Tagen gefunden. Wir werden versuchen, dieses Problem durch Ausführen eines Skripts auf deinem Computer zu beheben.",
                        "action": "Säubere den Chrome Browser Cache",
                        "actionInfo": "Hierdurch wird der Chrome Browser Cache gesäubert. Es werden keine persönlichen Dateien modifiziert."
                    },
                    "ZScalarStatus": {
                        "message": "Wir haben festgestellt, dass der Zscaler-Dienst auf deinem Gerät einige Probleme hatte. Wir können versuchen, dies zu beheben, indem wir ein Skript auf deinem Computer ausführen.",
                        "action": "Starte den Zscaler Service neu",
                        "actionInfo": "Diese Aktion wird deine Netzwerk Verbindung neustarten. Es wird keine Auswirkungen auf deine bereits geöffneten Programme geben."
                    },
                    "ZScalarState": {
                        "message": "Wir haben festgestellt, dass der Zscaler-Dienst auf deinem Gerät einige Probleme hatte. Wir können versuchen, dies zu beheben, indem wir ein Skript auf deinem Computer ausführen.",
                        "action": "Zscaler zurücksetzen",
                        "actionInfo": "Diese Aktion wird deine Netzwerk Verbindung neustarten. Es wird keine Auswirkungen auf deine bereits geöffneten Programme geben."
                    },
                    "driveFreeSpace": {
                        "message": "Auf deinem Gerät sind nur noch <n> GB freier Speicherplatz verfügbar. Um eine optimale Leistung deines Computers zu gewährleisten, empfehlen wir dir, den für Windows verfügbaren freien Speicherplatz zu vergrößern, indem wir ein Skript auf deinem Computer ausführen.",
                        "action": "Führe Datenträgerbereinigung durch",
                        "actionInfo": "Bei dieser Aktion werden nur temporäre Dateien und der Papierkorb deines Geräts bereinigt."
                    },
                    "daysSinceFullBoot": {
                        "message": "Dein Gerät wurde in den letzten <n> Tagen nicht vollständig neu gestartet. Dies unterscheidet sich vom normalen Herunterfahren. Wir empfehlen, deinen Computer vollständig neu zu starten (Start | Herunterfahren | Neu starten).",
                        "action": "Starte dein Gerät bei nächster Gelegenheit neu.",
                        "actionInfo": ""
                    },
                    "teamsCrashes": {
                        "message": "Wir haben Hinweise auf <n> Abstürze im Zusammenhang mit Microsoft Teams in den letzten 7 Tagen gefunden. Wir können versuchen, dieses Problem zu beheben, indem wir ein Skript ausführen, um deinen Microsoft Teams-Cache zu löschen.",
                        "action": "MS Teams Cache säubern",
                        "actionInfo": "Diese Aktion säubert den MS Teams Cache und startet die Anwendung neu- Entwürfe bzw. ungesendete Nachrichten werden auch gelöscht."
                    },
                    "teamsPluginDisabled": {
                        "message": "Wir haben festgestellt, dass dein Microsoft Teams-Add-In innerhalb von Microsoft Outlook deaktiviert ist. Dies führt zu Problemen zwischen den beiden Anwendungen. Wir können versuchen, es zu beheben, indem wir ein Skript ausführen, um die Einstellungen neu zu konfigurieren.",
                        "action": "Outlook Plugins auswählen",
                        "actionInfo": "Diese Aktion aktiviert das Teams Plugin in deinem Outlook und startet die Anwendung neu."
                    },
                    "outlookOstStatus": {
                        "message": "Unser Outlook-Profil hat seine optimale Größe überschritten, was bekanntermaßen zu Problemen mit deinem Postfach führt. Wir können versuchen, es mit einem Skript zu beheben, um diese Datei neu zu erstellen.",
                        "action": "Repariere das Outlook OST File",
                        "actionInfo": "Dies benennt deine Outlook OST Datei um und startet die Anwendung neu. Dabei werden alle E-Mail Entwürfe gelöscht."
                    },
                    "lastOsUpdate": {
                        "message": "Wir können sehen, dass dein Windows Update-Dienst nicht wie erwartet ausgeführt wird und dein Computer zuletzt vor <n> Tagen aktualisiert wurde. Wir empfehlen, deinen Computer vollständig neu zu starten (Start | Herunterfahren | Neustart), um einige Einstellungen zurückzusetzen.",
                        "action": "Starte dein Gerät bei nächster Gelegenheit neu",
                        "actionInfo": ""
                    }
                },
                "acknowledgeQuery": "Ich kann bei der Fehlerbehebung an Ihrem Gerät helfen. Lassen Sie uns das Problem prüfen und lösen"
            },
            "declineScriptMsg": "Ich möchte das Nexthink Skript nicht ausführen, helfen Sie mir mit einer anderen Lösung",
            "recommendedAction": "Empfohlene Aktion",
            "noKbArticleFound": "Es wurden keine manuellen Schritte oder Wissensartikel zu diesem Problem gefunden. Es gibt jedoch eine empfohlene Aktion, die das Problem möglicherweise lösen kann:",
            "timezone": {
                "primaryBtn": "Ja, weiter fortfahren",
                "secondaryBtn": "Nein, nicht aktualisieren",
                "successMsg": "Die Zeitzonenerkennung wurde auf automatisch eingestellt",
                "successMsgOnList": "Die Zeitzonenerkennung wurde auf automatisch eingestellt",
                "failureMsg": "Die Zeitzonenkonfiguration konnte nicht aktualisiert werden",
                "progressMsg": "Aktualisierung der Zeitzoneneinstellungen",
                "disclaimer": "Bitte beachten Sie, dass diese Aktion darauf ausgelegt ist, den Zeitzonenservice auf automatisch zu setzen, sodass Windows die Desktop-Uhr basierend auf dem erkannten Standort aktualisieren kann.",
                "acknowledgeQuery": "Ich kann Ihnen helfen, Ihre Systemzeit- und Zeitzoneneinstellungen zu korrigieren. Die meisten zeitbezogenen Probleme wie Uhrabweichung, falsche Zeitstempel, fehlgeschlagene Authentifizierungscodes oder falsche Besprechungszeiten werden durch eine falsche Zeitzone oder deaktivierte Auto-Synchronisierung verursacht. Bitte klicken Sie auf die Schaltfläche unten, um Ihre Windows-Zeit- und Zeitzonenkonfiguration automatisch zu erkennen und zu korrigieren."
            },
            "chooseBrowser": "Wählen Sie den Browser für die Cache-Bereinigungsaktion aus",
            "outlookAutoComplete": {
                "primaryBtn": "Ja, Outlook-Cache löschen",
                "secondaryBtn": "Nein, Outlook-Cache nicht löschen",
                "successMsg": "Outlook-Autovervollständigungs-Cache wurde gelöscht",
                "successMsgOnList": "Outlook-Autovervollständigungs-Cache wurde gelöscht",
                "failureMsg": "Outlook-Autovervollständigungs-Cache konnte nicht gelöscht werden",
                "progressMsg": "Outlook-Autovervollständigungs-Cache wird gelöscht",
                "disclaimer": "Bitte beachten Sie, dass durch das Löschen des Outlook-Autovervollständigungs-Caches gespeicherte E-Mail-Adressvorschläge entfernt werden. Diese Aktion kann nicht rückgängig gemacht werden.",
                "acknowledgeQuery": "Ich kann Ihnen helfen, den Outlook-Autovervollständigungs-Cache zu korrigieren. Bitte klicken Sie auf die Schaltfläche unten, um Ihre Outlook-Autovervollständigung automatisch zu reparieren."
            },
            "restartZscalar": {
                "primaryBtn": "Ja, weiter fortfahren",
                "secondaryBtn": "Nein, Zscaler nicht neu starten",
                "successMsg": "Zscaler wurde neu gestartet",
                "successMsgOnList": "Zscaler wurde neu gestartet",
                "failureMsg": "Zscaler konnte nicht neu gestartet werden",
                "progressMsg": "Zscaler-Dienste werden neu gestartet",
                "disclaimer": "Bitte beachten Sie, dass ein Neustart von Zscaler Ihre Internetverbindung und Arbeitsanwendungen kurzzeitig unterbrechen kann. Dies dauert in der Regel weniger als eine Minute.",
                "acknowledgeQuery": "Ich kann Ihnen helfen, Probleme mit Ihren Zscaler-Diensten zu beheben. Bitte klicken Sie auf die Schaltfläche unten, um Ihre Zscaler-Probleme zu beheben."
            },
            "onedrive": {
                "primaryBtn": "Ja, OneDrive reparieren",
                "secondaryBtn": "Nein, die OneDrive-Reparatur nicht ausführen",
                "successMsg": "Die OneDrive-Reparatur wurde abgeschlossen",
                "successMsgOnList": "Die OneDrive-Reparatur wurde abgeschlossen",
                "failureMsg": "Die OneDrive-Reparatur konnte nicht erfolgreich abgeschlossen werden",
                "progressMsg": "OneDrive-Reparatur wird ausgeführt",
                "disclaimer": "Bitte beachten Sie, dass eine Reparatur von OneDrive dazu führt, dass lokale Dateien mit der Cloud synchronisiert werden und benutzerdefinierte Synchronisierungen für OneDrive möglicherweise nicht mehr funktionieren.",
                "acknowledgeQuery": "Ich kann Ihnen helfen, Ihre OneDrive-Probleme zu beheben. Bitte klicken Sie auf die Schaltfläche unten, um Ihre OneDrive-Probleme zu beheben."
            },
            "smartcard": {
                "primaryBtn": "Ja, Smartcard entfernen",
                "secondaryBtn": "Nein, die Smartcard nicht entfernen",
                "successMsg": "Die Microsoft-Smartcard wurde entfernt",
                "successMsgOnList": "Die Microsoft-Smartcard wurde entfernt",
                "failureMsg": "Die Microsoft-Smartcard kann nicht entfernt werden",
                "progressMsg": "Microsoft-Smartcard wird entfernt",
                "disclaimer": "Die Ausführung dieser Aktion kann bis zu 1 Minute dauern.",
                "acknowledgeQuery": "Ich kann Ihnen helfen, Probleme mit dem Microsoft Smart Card Reader zu beheben. Bitte klicken Sie auf die Schaltfläche unten, um Ihre Smart Card-Probleme zu beheben."
            },
            "errorFetchingReport": "Leider konnte ich den Bericht nicht abrufen. Bitte versuchen Sie es später erneut.",
            "automatedFix": "Automatische Fehlerbehebung",
            "automatedFixConsent": "Ich kann dieses Problem auf Ihrem Gerät beheben. Möchten Sie, dass ich die automatische Fehlerbehebung starte?",
            "primaryButton": "Ja, die Fehlerbehebung starten",
            "teamViewerReset": {
                "primaryBtn": "Ja, fortfahren",
                "secondaryBtn": "Nein, nicht zurücksetzen",
                "successMsg": "Teamviewer-Dienste wurden zurückgesetzt",
                "successMsgOnList": "Teamviewer-Dienste wurden zurückgesetzt",
                "failureMsg": "Zurücksetzen der Teamviewer-Dienste nicht möglich",
                "progressMsg": "Teamviewer-Dienste werden neu gestartet",
                "disclaimer": "Diese Aktion setzt Ihre teamviewer-Dienste zurück und startet Ihre teamviewer-App neu. Bitte stellen Sie sicher, dass Ihre Arbeit gespeichert ist, bevor Sie fortfahren.",
                "acknowledgeQuery": "Ich kann beim Zurücksetzen von Teamviewer helfen. Bitte klicken Sie auf die Schaltfläche unten, um fortzufahren."
            },
            "zoomUninstall": {
                "primaryBtn": "Ja, Zoom deinstallieren",
                "secondaryBtn": "Nein, nicht deinstallieren",
                "successMsg": "Zoom deinstalliert",
                "successMsgOnList": "Zoom deinstalliert",
                "failureMsg": "Zoom kann nicht entfernt werden",
                "progressMsg": "Deinstallation von Zoom wird durchgeführt",
                "disclaimer": "Diese Aktion deinstalliert Zoom von Ihrem Gerät; dabei werden auch alle Konfigurationen für Zoom gelöscht.",
                "acknowledgeQuery": "Ich kann bei der Deinstallation von Zoom helfen. Bitte klicken Sie auf die Schaltfläche unten, um fortzufahren."
            },
            "webexUninstall": {
                "primaryBtn": "Ja, Webex deinstallieren",
                "secondaryBtn": "Nein, nicht deinstallieren",
                "successMsg": "Webex deinstalliert",
                "successMsgOnList": "Webex deinstalliert",
                "failureMsg": "Webex kann nicht entfernt werden",
                "progressMsg": "Deinstallation von Webex wird durchgeführt",
                "disclaimer": "Diese Aktion deinstalliert Cisco Webex von Ihrem Gerät; dabei werden auch alle Konfigurationen für Cisco Webex gelöscht.",
                "acknowledgeQuery": "Ich kann bei der Deinstallation von Cisco Webex helfen. Bitte klicken Sie auf die Schaltfläche unten, um fortzufahren."
            }
        },
        "sessions": {
            "title": "Letzte Chats",
            "deleteMessage": "Sitzung löschen",
            "clearAll": "Alle löschen",
            "footer": "Hinweis: Die letzten 30 Tage der Konversation werden gespeichert.",
            "noRecentChat": "Keine letzten Chats",
            "startNewChat": "Neuen Chat starten",
            "learnMore": "Mehr erfahren.",
            "learnMoreTooltip": "Laut der MyHelp-Aufbewahrungsrichtlinie sind Ihre letzten Chats 30 Tage lang verfügbar, es sei denn, Sie löschen die letzten Chats mit den Schaltflächen Löschen oder Alle löschen."
        },
        "chatIcon": "ChatBot",
        "incError": "Bitte geben Sie gültige Vorfalldetails ein",
        "contactError": "Bitte geben Sie eine gültige Telefonnummer ein",
        "searchAsk": "Beschreiben Sie Ihr Anliegen, z. B. Passwort zurücksetzen...",
        "teamsInsights": {
            "specifyDateTime": "Könnten Sie bitte Datum und Uhrzeit angeben, zu der dies aufgetreten ist, sowie das betroffene Meeting oder den betroffenen Chat?",
            "date": "Datum",
            "getMeetings": "Meetings abrufen",
            "cancel": "Abbrechen",
            "noMeetings": "Für das ausgewählte Datum wurden keine Meetings gefunden.",
            "meetingInstruction": "Bitte wählen Sie das konkrete Meeting aus, das von den Qualitätsproblemen betroffen war.",
            "identifyIssue": "Problem identifizieren",
            "issueDetectionCompleted": "Problemerkennung abgeschlossen.",
            "detectingIssues": "Probleme im Meeting werden erkannt",
            "recommendedActions": "Empfohlene Maßnahmen:",
            "noInsightsFound": "Für den ausgewählten Anruf wurden keine Erkenntnisse gefunden.",
            "meetingList": "Meeting-Liste",
            "fetchingMeetings": "Alle Teams-Meetings für den Tag werden abgerufen",
            "windowsOnly": "Meeting-Erkenntnisse sind nur für Anrufe verfügbar, denen mit Windows-Geräten beigetreten wurde.",
            "confirmCreateIncident": "Möchten Sie ein Incident-Ticket für das im Meeting erkannte Problem erstellen?",
            "getMeetingsCancelMsg": "Die Anfrage zum Abrufen der Meetings wurde abgebrochen.",
            "identifyIssueCancelMsg": "Die Anfrage zur Problemidentifizierung wurde abgebrochen.",
            "createIncidentCancelMsg": "Die Anfrage zur Erstellung eines Vorfalls wurde abgebrochen.",
            "report": {
                "lowWifiRootCause": "Ihr WLAN-Signal war während des Anrufs schwach, was zu Qualitätsproblemen geführt haben könnte. Bitte prüfen Sie den Abstand zu Ihrem Router, wenn Sie aus einem Heim-/Remote-Netzwerk verbunden waren.",
                "networkIssueRootCauseManaged": "Es sieht so aus, als wären Sie von einem E.ON-Büro aus verbunden gewesen und hätten Netzwerkprobleme erlebt, die die Meeting-Qualität beeinträchtigt haben. Bitte erwägen Sie, ein Incident-Ticket zu eröffnen und den Standort, an dem Sie sich befanden, im Ticket zu vermerken.",
                "networkIssueRootCauseUnmanaged": "Es sieht so aus, als wären Sie nicht von einem E.ON-Büro aus verbunden gewesen und hätten Netzwerkprobleme erlebt, die die Meeting-Qualität beeinträchtigt haben könnten. Bitte prüfen Sie die Stabilität Ihrer lokalen WLAN- oder Internetverbindung. Verwenden Sie nach Möglichkeit eine Kabelverbindung oder verringern Sie den Abstand zu Ihrem WLAN-Router, um die Netzwerkleistung zu verbessern.",
                "noDataRootCause": "Für diesen Parameter lagen während des Anrufs keine Erkenntnisse vor.",
                "noIssueRootCause": "Für diesen Parameter wurde kein Problem erkannt.",
                "noIssueRecommendation": "Keine Aktion erforderlich.",
                "failed": "Fehlgeschlagen",
                "checking": "Wird geprüft",
                "okay": "In Ordnung",
                "na": "k. A.",
                "audio": "Audio",
                "video": "Video",
                "deviceCpuUsage": {
                    "displayName": "CPU-Auslastung des Geräts",
                    "rootCause": "Wir haben während des Anrufs eine hohe CPU-Auslastung auf Ihrem Gerät festgestellt. Bitte prüfen Sie, ob während des Anrufs Hintergrundprozesse oder Apps geöffnet und aktiv waren, und vermeiden Sie es, zu viele Apps gleichzeitig offen zu halten, damit die Hardwareleistung des Geräts dem Meeting zugewiesen werden kann.",
                    "recommendation": "Schließen Sie während Anrufen unnötige Hintergrundanwendungen, um die CPU-Auslastung zu reduzieren."
                },
                "deviceMemoryUsedPct": {
                    "displayName": "Speicherauslastung des Geräts",
                    "rootCause": "Wir haben während des Anrufs eine hohe Speicherauslastung auf Ihrem Gerät festgestellt. Bitte prüfen Sie, ob während des Anrufs Hintergrundprozesse oder Apps geöffnet und aktiv waren, und vermeiden Sie es, zu viele Apps gleichzeitig offen zu halten, damit die Hardwareleistung des Geräts dem Meeting zugewiesen werden kann.",
                    "recommendation": "Schließen Sie während Anrufen unnötige Hintergrundanwendungen, um die Speicherauslastung zu reduzieren."
                },
                "wifiSignalQuality": {
                    "displayName": "WLAN-Signalqualität",
                    "recommendation": "Gehen Sie näher an Ihren Router oder wechseln Sie zu einer stärkeren WLAN-Signalquelle."
                },
                "audioJitter": {
                    "displayName": "Audio-Jitter"
                },
                "audioJBDelay": {
                    "displayName": "Audio-JB-Verzögerung"
                },
                "audioRecvLossRate": {
                    "displayName": "Audio-Empfangsverlustrate"
                },
                "audioRtt": {
                    "displayName": "Audio-Round-Trip-Zeit"
                },
                "videoRtt": {
                    "displayName": "Video-Round-Trip-Zeit"
                },
                "videoRecvLossRate": {
                    "displayName": "Video-Empfangsverlustrate"
                },
                "wifiChannelCenterFrequencyInKilohertz": {
                    "displayName": "WLAN-Kanal-Mittenfrequenz (kHz)",
                    "rootCause": "Sie verwenden eine 2,4-GHz-WLAN-Verbindung, die häufig zu Problemen bei der Anrufqualität führt. Bitte erwägen Sie, auf ein 5-GHz-WLAN-Band oder höher zu wechseln.",
                    "recommendation": "Wechseln Sie zu einem 5-GHz-WLAN-Band (oder höher), um die Anrufqualität zu verbessern."
                },
                "wifiSsidChangeDetected": {
                    "displayName": "Netzwerkwechsel erkannt",
                    "rootCauseManaged": "Wir haben WLAN- oder Access-Point-Wechsel während Ihres Anrufs in einem E.ON-Büro festgestellt. Dies könnte zu einer Unterbrechung des Anrufs geführt haben. Wenn Sie sich mit Ihrem Gerät nicht bewegt haben, registrieren Sie dies bitte als Incident-Ticket.",
                    "rootCauseUnmanaged": "Wir haben festgestellt, dass Sie nicht von einem E.ON-Standort aus verbunden waren. Bitte prüfen Sie, ob Ihre WLAN-Verbindung stabil ist, da Netzwerkprobleme die Meeting-Qualität beeinträchtigen können."
                }
            }
        }
    },
    "searchPage": {
        "searchPlaceholder": "Suchen...",
        "searchApps": "Suche hier...",
        "relatedApps": "Apps",
        "viewMoreApps": "weitere",
        "removeAppTooltip": "Vom Dashboard entfernen",
        "addAppTooltip": "Zum Dashboard hinzufügen",
        "addedAppTooltip": "Zum Dashboard hinzugefügt"
    },
    "pwaText": {
        "header": "Installieren Sie diese App auf Ihrem Home-Bildschirm!",
        "button": "App installieren",
        "iphoneHeader": "Um diese App auf dem iPhone zu installieren",
        "inst1": "Tippen Sie in Safari auf die Schaltfläche <b>Teilen</b>.",
        "inst2": "Scrollen Sie nach unten und wählen Sie <b>\"Zum Home-Bildschirm hinzufügen\".</b>",
        "inst3": "Tippen Sie oben rechts auf <b>Hinzufügen</b>."
    },
    "filterPage": {
        "filterMenu": {
            "enterSearchTerm": "Geben Sie Ihr Suchwort ein und verfeinern Sie Ihre Ergebnisse.",
            "disclaimer": "Einige Ergebnisse sind möglicherweise nicht vollständig relevant. Bitte überprüfen Sie diese sorgfältig.",
            "backBtn": "zurück zur vorherigen Seite",
            "loading": "Loading",
            "app": "Apps",
            "apps": "Apps",
            "m365": "Meine Dateien",
            "emails": "Meine Emails",
            "teams": "Teams",
            "people": "Personen",
            "jql": "jql",
            "all": "Alle",
            "community": "Gemeinschaft",
            "pages": "Seiten",
            "users": "Benutzer",
            "noData": "Wir konnten keine Ergebnisse finden für",
            "noMoreData": "Zu Ihrer Anfrage wurden keine weiteren Ergebnisse gefunden!",
            "filterHeading": "Filter",
            "reset": "Filter zurücksetzen",
            "refineResults": "Ergebnisse verfeinern",
            "priority": "Priorität",
            "status": "Status",
            "card_languages": "Sprachen",
            "ecl_source_name": "Quelle",
            "standard_card_type": "Typ",
            "mimeType": "Typ",
            "space": "Bereiche",
            "gitlab": "Gitlab",
            "datasources": "Datenquellen",
            "lookingFor": "Ich suche nach",
            "timeRange": "Zeitbereich",
            "department": "Abteilung",
            "mygenius": "My Genius",
            "jira": "Jira",
            "confluence": "Confluence",
            "orderit": "My IT order",
            "aiAssistant": "Assistance",
            "compass": "Compass",
            "categoryTags": "Kategorie",
            "kb_articles": "IT Support",
            "officeBuddy": "E.ON Knowledge base",
            "key": "Projekt",
            "companyTags": "Geschäftsbereich",
            "searchIn": "Suche in",
            "time": "Zeit"
        },
        "searchResult": {
            "source": "Quelle",
            "business": "Geschäft",
            "mobile": "Mobil",
            "type": "Art",
            "duration": "Dauer",
            "category": "Kategorie",
            "deliveryTime": "Lieferzeit",
            "availableLanguages": "Verfügbare Sprachen",
            "status": "Status",
            "lastUpdate": "Letzte Aktualisierung",
            "lastUpdated": "Letzte Aktualisierung",
            "createdOn": "Erstellt am",
            "createdBy": "Erstellt von",
            "company": "Unternehmen",
            "department": "Abteilung",
            "job_title": "Berufsbezeichnung",
            "office_location": "Bürostandort",
            "email": "Email",
            "preview": "Vorschau",
            "viewEmail": "Email anzeigen"
        },
        "timeRangeOptions": {
            "All": "Alle",
            "yesterday": "1 Tag",
            "lastWeek": "7 Tage",
            "lastMonth": "1 Monat",
            "lastYear": "1 Jahr",
            "6 Months": "6 Monate"
        },
        "dataSources": {
            "Confluence": "Confluence",
            "Gitlab": "Gitlab",
            "JIRA": "Jira",
            "MyGenius": "MyGenius",
            "ItOrder": "my IT order",
            "Sharepoint": "SharePoint",
            "Knowledge Base": "Knowledge Base",
            "powerpoint": "PowerPoint",
            "word": "Word",
            "excel": "Excel",
            "pdf": "PDF",
            "loop": "Loop",
            "other": "Andere"
        },
        "searchOptions": {
            "local": "<BU>",
            "compassWide": "Alle Geschäftsbereiche"
        },
        "searchOptionsHover": "Zeigt Inhalte aus Ihrem Geschäftsbereich, Inhalte der E.ON-Gruppe oder Inhalte aus anderen Geschäftsbereichen."
    },
    "snow": {
        "welcomeNote": "Nachfolgend finden Sie eine Übersicht über Ihre offenen Incident-Tickets, Ihre Anfragen und Ihre IT-Ressourcen.",
        "tabName": {
            "incidents": "Vorfälle",
            "orders": "Aufträge",
            "itResources": "IT-Ressourcen",
            "incidentsTable": {
                "noData": "Keine Daten verfügbar",
                "btnText": "Neue Störung eröffnen",
                "ongoing": "Laufend",
                "closed": "Geschlossen",
                "headlineText": "Vorfälle"
            },
            "orderTable": {
                "number": "Nummer",
                "catItem": "Cat Artikel",
                "approvalSet": "Genehmigungssatz",
                "state": "Zustand",
                "dueDate": "Fälligkeitsdatum",
                "createdOn": "Erstellt am",
                "noData": "Keine Daten verfügbar",
                "btnText": "Bestellen Sie IT-Dienstleistungen",
                "headlineText": "Bestellungen",
                "tooltipText": "IT-Geräte, Software, Lizenzen oder Services anfordern und verwalten"
            },
            "itResourcesTable": {
                "modelCategory": "Modellkategorie",
                "model": "Modell",
                "computerName": "Computername",
                "serialNumber": "Seriennummer",
                "serviceValue1": "Servicewert1",
                "serviceValue2": "Servicewert2",
                "noData": "Keine Daten verfügbar",
                "btnText": "Öffnen Sie ein Ticket für IT-Ressourcen",
                "headlineText": "Meine IT-Ressourcen"
            }
        }
    },
    "moveTabAndTiles": {
        "tabNames": "Tab",
        "favourite": "Favoriten",
        "categorizeTiles": "Personalisiertes Dashboard",
        "enterTabName": "Reiternamen eigeben",
        "tabInputLabel": "Reitername",
        "addTabButton": "Reiter hinzufügen",
        "tabNameError": "Bitte gib einen eindeutigen Reiternamen ein, der mindestens 2 und höchstens 20 Zeichen lang ist",
        "personalizeTab": "Reiter personalisieren",
        "personalizeTiles": "Kacheln personalisieren",
        "addTab": "Neuen Reiter hinzufügen",
        "removeTabConfrim": "Bist du sicher, dass du den Reiter ",
        "with": " mit",
        "cardIn": "Kacheln löschen willst?",
        "actionUndone": "Diese Aktion kann nicht rückgängig gemacht werden.",
        "categorizeTilesTitle": "Reiter umbenennen, Reiter entfernen, Kacheln innerhalb des Reiters verschieben",
        "addTabTitle": "Neuen Reiter hinzufügen.",
        "organiseTilesTitle": "Kachelposition anpassen"
    },
    "dataTable": {
        "pagingData": "Objekte pro Seite",
        "itemString": "Objekte",
        "ofString": "von"
    },
    "tourData": {
        "userActions": {
            "back": "Zurück",
            "close": "Schließen",
            "last": "Beenden",
            "next": "Weiter",
            "step": "Schritt",
            "of": "von",
            "open": "Dialog öffnen",
            "skip": "Überspringen",
            "start_tour": "Tour starten",
            "tour_info": "Möchtest du die Grundfunktionen in einer kurzen Guided Tour kennen lernen? Es sollte nicht länger als 1-2 Minuten dauern..."
        },
        "tile": {
            "step1": "Nutze MyHelp, um deine typischen Arbeitsanwendungen zu finden oder stelle Fragen zu allen E.ON-Ressourcen – zum Beispiel zur IT, deinen Projekten, Schulungen, Unternehmensrichtlinien und vielem mehr.",
            "step2": "In der MyHelp Benutzerdokumentation findest du weitere Informationen, Funktionen & Antworten auf häufig gestellte Fragen sowie hilfreiche Tipps und Tricks.",
            "step3": "Du kannst die bevorzugte Sprache jederzeit von hier aus ändern",
            "step4": "Du kannst dich abmelden, indem du hier klickst",
            "step5": "Beginne mit einer neuen Unterhaltung, rufe deine letzten Chats auf, um dort weiterzumachen, wo du aufgehört hast oder starte eine E.ON Suche durch Drücken der Lupe",
            "step6": "Über Ihr personalisiertes Dashboard können Sie Ihre bevorzugten Arbeitsanwendungen organisieren und darauf zugreifen. Suchen Sie nach einer App und fügen Sie sie mit dem Pluszeichen hinzu. Erstellen Sie neue Registerkarten und ordnen Sie Apps nach Bedarf neu an."
        },
        "tab": {
            "step1": "Du kannst einen neuen Reiter hinzufügen, indem Du hier klickst",
            "step2": "Klicke hier, um die Reihenfolge der Kacheln zu organisieren.",
            "step3": "Hier kannst du Reiter umbenennen und organisieren"
        },
        "chat": {
            "step1": "Beschreibe dein IT-Problem",
            "step1_description": "Erhalte Schritt-für-Schritt-Hilfe für häufige IT-Probleme – basierend auf den E.ON IT-Support-Wissensdatenbanken. Bei Bedarf leitet dich MyHelp auch zum passenden IT-Support-Kanal weiter.",
            "step2": "Typische IT-Anliegen entdecken",
            "step2_description": "Diese Beispiele zeigen häufige IT-Anliegen, bei denen MyHelp dich Schritt für Schritt unterstützen kann.",
            "step3": "Greife schneller auf deine Apps zu",
            "step3_description": "Nutze das Dashboard, um häufig verwendete Anwendungen zu speichern und deinen persönlichen Workspace zu erstellen.",
            "step4": "Starte einen neuen Chat oder setze frühere Gespräche fort",
            "step4_description": "Nutze die Seitenleiste, um eine neue Unterhaltung zu starten oder schnell zu früheren Chats zurückzukehren."
        }
    },
    "allApps": {
        "addAppsBtn": "Apps hinzufügen",
        "addAppsInfo": "Klicke auf „Apps hinzufügen“, um zu beginnen",
        "addAppsTitle": "Erstelle deinen persönlichen Workspace",
        "addAppsDesc": "Füge deine meistgenutzten Anwendungen hinzu, um schneller auf deine Apps zuzugreifen",
        "customTileButton": "Benutzerdefinierte Karte hinzufügen",
        "CustomTileHeading": "Benutzerdefinierte Karte",
        "customTileTitleLabel": "Kartentitel",
        "customTileSubTitle": "Kartenbeschreibung",
        "customTileUrlLabel": "Kartenlink",
        "createCardBtn": "Karte erstellen",
        "modalHeading": "Apps bei E.ON",
        "modalDesc": "Suche oder wähle eine App aus, um diese zur Startseite hinzuzufügen",
        "titleRequired": "Kartentitel ist erforderlich",
        "linkRequired": "Kartenlink ist erforderlich",
        "searchPlaceholder": "App suchen"
    },
    "onboardingPortal": {
        "onboardAppBtn": "Onboarding-Portal",
        "heading": "Onboarding Portal",
        "subHeading": "Überprüfen Sie Ihre App, integrieren Sie neue und teilen Sie den Verwaltungszugriff mit Ihrem Team.",
        "modules": {
            "home": "Startseite",
            "apps": "Apps",
            "appsLabel": "Apps",
            "qna": "Q&A",
            "qnaLabel": "Frage & Antwort",
            "review": "Prüfung",
            "reviewLabel": "Prüfung",
            "onboardApp": "Neue App integrieren",
            "manageApp": "Apps verwalten",
            "defaultApps": "Standard-Apps",
            "onboardQnA": "QnA integrieren",
            "manageQnA": "QnA verwalten",
            "reviewDashboard": "Reviewer-Dashboard",
            "reviewApps": "Apps prüfen",
            "reviewQnA": "Q&A prüfen"
        },
        "appOnboardingForm": {
            "formHeading": "Neue App integrieren",
            "successAlert": "App erfolgreich integriert!",
            "appTitleLabel": "App-Titel",
            "appTitleTooltip": "Anzuzeigender App-Name",
            "appTitlePlaceholder": "Anzuzeigender App-Name",
            "appTitleError": "App-Titel ist erforderlich",
            "appSubTitleLabel": "App-Untertitel",
            "appSubTitleTooltip": "Untertitel der App",
            "appSubTitlePlaceholder": "Untertitel der App",
            "appSubTitleError": "App-Untertitel ist erforderlich",
            "appUrlLabel": "App-URL",
            "appUrlTooltip": "Ziel-URL der App",
            "appUrlPlaceholder": "Ziel-URL der App",
            "appUrlError": "App-URL ist erforderlich",
            "appKeywordsLabel": "SynKeywords (kommagetrennt)",
            "appKeywordsTooltip": "Synonyme eingeben, die Benutzer möglicherweise verwenden, um die App zu finden, und durch Komma trennen",
            "appKeywordsPlaceholder": "Synonyme eingeben, die Benutzer möglicherweise verwenden, um die App zu finden, und durch Komma trennen",
            "appKeywordsError": "Keywords sind erforderlich",
            "appCompaniesAllowedLabel": "Erlaubte Unternehmen",
            "appCompaniesAllowedTooltip": "Liste aller Unternehmen, für die diese App erlaubt ist. Falls für alle erlaubt, leer lassen.",
            "appCompaniesAllowedInfoMessage": "Liste aller Unternehmen, für die diese App erlaubt ist. Falls für alle erlaubt, leer lassen.",
            "appCompaniesAllowedOtherLabel": "Weitere erlaubte Unternehmen",
            "appCompaniesAllowedOtherPlaceholder": "Weitere erlaubte Unternehmen angeben",
            "appCompaniesRestrictedLabel": "Eingeschränkte Unternehmen",
            "appCompaniesRestrictedTooltip": "Liste aller Unternehmen, für die diese App NICHT erlaubt ist. Falls keine Einschränkung, leer lassen.",
            "appCompaniesRestrictedInfoMessage": "Liste aller Unternehmen, für die diese App NICHT erlaubt ist. Falls keine Einschränkung, leer lassen.",
            "appCompaniesRestrictedOtherLabel": "Weitere eingeschränkte Unternehmen",
            "appCompaniesRestrictedOtherPlaceholder": "Weitere eingeschränkte Unternehmen angeben",
            "appTooltipLabel": "Tooltip (alle Sprachen angeben, falls abweichende Namen angezeigt werden sollen)",
            "appTooltipTooltip": "Alle Sprachen angeben, falls abweichende Namen angezeigt werden sollen, z.B. EN- This is My HR tooltip, DE- Dies ist mein HR-Tooltip",
            "appTooltipPlaceholder": "Alle Sprachen angeben, falls abweichende Namen angezeigt werden sollen, z.B. EN- This is My HR tooltip, DE- Dies ist mein HR-Tooltip",
            "appTooltipError": "Tooltip ist erforderlich",
            "appIconLabel": "App-Symbol hochladen",
            "appIconTooltip": "App-Symbol hochladen",
            "previewAppBtn": "App-Vorschau",
            "cancelBtn": "Abbrechen",
            "closeBtn": "Schließen",
            "submitAppBtn": "App einreichen",
            "updateAppBtn": "App aktualisieren",
            "editAppBtn": "App bearbeiten",
            "appTitlePreview": "Titel",
            "appSubTitlePreview": "Untertitel",
            "appUrlPreview": "URL",
            "appKeywordsPreview": "Keywords",
            "appCompaniesAllowedPreview": "Erlaubte Unternehmen",
            "appCompaniesRestrictedPreview": "Eingeschränkte Unternehmen",
            "appTooltipPreview": "Tooltip",
            "message": "Sobald eine App eingereicht wird, erhält sie den Status Ausstehend und durchläuft einen definierten Prüfungslebenszyklus — von Ausstehend → Genehmigt (in Prüfung/Test) → In QA (formell genehmigt und wird verifiziert) → In Produktion (live und für Endbenutzer auf MyHelp sichtbar), oder sie wird Abgelehnt, wenn sie die Kriterien nicht erfüllt; in diesem Fall kann der Stakeholder sie bearbeiten und erneut einreichen."
        },
        "qnaOnboardingForm": {
            "formHeading": "Neues QnA integrieren",
            "successAlert": "QnA erfolgreich integriert!",
            "qnaQuestionLabel": "Frage",
            "qnaQuestionTooltip": "Frage für das QnA-Element eingeben",
            "qnaQuestionPlaceholder": "Frage eingeben",
            "qnaQuestionError": "Frage ist erforderlich",
            "qnaAnswerLabel": "Antwort",
            "qnaAnswerTooltip": "Antwort für das QnA-Element eingeben",
            "qnaAnswerPlaceholder": "Antwort auf die Frage eingeben",
            "qnaAnswerError": "Antwort ist erforderlich",
            "qnaCategoryLabel": "Kategorie",
            "qnaCategoryTooltip": "Kategorie für das QnA-Element auswählen",
            "qnaCategoryPlaceholder": "Kategorie für das QnA-Element auswählen",
            "qnaCategoryError": "Kategorie ist erforderlich",
            "qnaCategoryOtherLabel": "Andere Kategorie",
            "qnaCategoryOtherPlaceholder": "Benutzerdefinierte Kategorie eingeben",
            "qnaCompaniesAllowedLabel": "Erlaubte Unternehmen",
            "qnaCompaniesAllowedTooltip": "Liste aller Unternehmen, für die diese App erlaubt ist. Falls für alle erlaubt, leer lassen.",
            "qnaCompaniesAllowedInfoMessage": "Liste aller Unternehmen, für die diese App erlaubt ist. Falls für alle erlaubt, leer lassen.",
            "qnaCompaniesAllowedOtherLabel": "Weitere erlaubte Unternehmen",
            "qnaCompaniesAllowedOtherPlaceholder": "Weitere erlaubte Unternehmen angeben",
            "qnaCompaniesRestrictedLabel": "Eingeschränkte Unternehmen",
            "qnaCompaniesRestrictedTooltip": "Liste aller Unternehmen, für die diese App NICHT erlaubt ist. Falls keine Einschränkung, leer lassen.",
            "qnaCompaniesRestrictedInfoMessage": "Liste aller Unternehmen, für die diese App NICHT erlaubt ist. Falls keine Einschränkung, leer lassen.",
            "qnaCompaniesRestrictedOtherLabel": "Weitere eingeschränkte Unternehmen",
            "qnaCompaniesRestrictedOtherPlaceholder": "Weitere eingeschränkte Unternehmen angeben",
            "previewQnABtn": "QnA-Vorschau",
            "cancelBtn": "Abbrechen",
            "submitQnABtn": "QnA einreichen",
            "updateQnABtn": "QnA aktualisieren",
            "editQnABtn": "QnA bearbeiten",
            "addNewQnABtn": "+ QnA hinzufügen",
            "qnaQuestionPreview": "Frage",
            "qnaAnswerPreview": "Antwort",
            "qnaCompaniesAllowedPreview": "Erlaubte Unternehmen",
            "qnaCompaniesRestrictedPreview": "Eingeschränkte Unternehmen",
            "message": "Sobald ein Q&A-Eintrag eingereicht wird, erhält er den Status Ausstehend und durchläuft einen definierten Prüfungslebenszyklus — von Ausstehend → Genehmigt (in Prüfung/Test) → In QA (formell genehmigt und wird verifiziert) → In Produktion (live und für Endbenutzer auf MyHelp sichtbar), oder er wird Abgelehnt, wenn er die Kriterien nicht erfüllt; in diesem Fall kann der Stakeholder ihn bearbeiten und erneut einreichen."
        },
        "manageBtn": "Verwalten",
        "refreshBtn": "Aktualisieren",
        "exportBtn": "Exportieren",
        "exportCsvBtn": "CSV",
        "exportExcelBtn": "Excel",
        "exportAppsCsvBtn": "Apps als CSV exportieren",
        "exportAppsExcelBtn": "Apps als Excel exportieren",
        "exportQnACsvBtn": "QnA als CSV exportieren",
        "exportQnAExcelBtn": "QnA als Excel exportieren",
        "approveBtn": "Genehmigen",
        "rejectBtn": "Ablehnen",
        "toQABtn": "In QA verschieben",
        "toProdBtn": "In Produktion verschieben",
        "editBtn": "Bearbeiten",
        "viewBtn": "Anzeigen",
        "closeBtn": "Schließen",
        "dashboard": {
            "appsTitle": "Zugängliche Apps",
            "appsText": "Apps, die Ihnen über Eigentümerschaft oder Teamfreigabe zur Verfügung stehen.",
            "qnaTitle": "Fragen & Antworten",
            "qnaText": "Fragen & Antworten, die Ihnen über Eigentümerschaft oder Teamfreigabe zur Verfügung stehen."
        },
        "modalLabel": {
            "reviewAppTitle": "App zur Integration prüfen",
            "reviewQnATitle": "Q&A zur Integration prüfen",
            "owner": "Eigentümer",
            "createdOn": "Erstellt am",
            "status": "Status",
            "url": "URL",
            "tooltip": "Tooltip",
            "companiesAllowed": "Erlaubte Unternehmen",
            "companiesRestricted": "Eingeschränkte Unternehmen",
            "keywords": "Schlüsselwörter",
            "reviewerComments": "Prüfkommentare",
            "category": "Kategorie",
            "question": "Frage",
            "answer": "Antwort",
            "mail": "E-Mail"
        },
        "statusLabel": {
            "pending": "Ausstehend",
            "approved": "Genehmigt",
            "rejected": "Abgelehnt",
            "onhold": "In Bearbeitung",
            "unknown": "Unbekannt",
            "all": "Alle",
            "inQA": "In QA",
            "inProd": "In Produktion"
        },
        "activityLabel": {
            "allowed": "Erlaubt",
            "restricted": "Eingeschränkt"
        },
        "tableHeaders": {
            "status": "Status",
            "action": "Aktion",
            "icon": "Symbol",
            "title": "Titel",
            "subTitle": "Untertitel",
            "question": "Frage",
            "answer": "Antwort",
            "category": "Kategorie",
            "owner": "Eigentümer",
            "description": "Beschreibung",
            "apps": "Apps",
            "qna": "Frage & Antwort",
            "defaultApps": "Standard-Apps",
            "defaultAppsActivity": "Änderungen an Standard-Apps",
            "search": "Suchen",
            "selectCompany": "Unternehmen auswählen",
            "otherCompany": "Name des anderen Unternehmens",
            "selectAll": "Alle auswählen",
            "company": "Unternehmen",
            "update": "Aktualisieren",
            "comments": "Kommentare"
        },
        "noData": {
            "dashboardEmpty": "Es wurden keine Apps oder Q&A hinzugefügt",
            "dashboardAppsEmpty": "Es wurden keine Apps hinzugefügt",
            "dashboardQnAEmpty": "Es wurden keine Q&A hinzugefügt",
            "reviewDashboardEmpty": "Es wurden keine Apps oder Q&A zur Prüfung eingereicht.",
            "reviewAppsEmpty": "Es wurden keine Apps zur Prüfung eingereicht.",
            "reviewQnAEmpty": "Es wurden keine Q&A zur Prüfung eingereicht."
        },
        "manageApp": {
            "heading": "Apps verwalten",
            "subHeading": "Hier werden nur Apps angezeigt, die Sie besitzen oder auf die Ihnen Zugriff gewährt wurde."
        },
        "manageQnA": {
            "heading": "QnA verwalten",
            "subHeading": "Hier werden nur QnAs angezeigt, die Sie besitzen oder auf die Ihnen Zugriff gewährt wurde."
        },
        "defaultApps": {
            "heading": "Standard-Apps",
            "subHeading": "Dies sind die Apps, die standardmäßig für alle Benutzer verfügbar sind. Sie können die angezeigten Apps durch Aktivieren oder Deaktivieren ändern.",
            "searchPlaceholder": "Nach Apps suchen"
        },
        "reviewDashboard": {
            "heading": "Prüfungsdashboard",
            "subHeading": "Prüfen Sie ausstehende App-Onboarding-Anfragen und genehmigen oder lehnen Sie sie ab. Ihre zeitnahen Prüfungen helfen uns, eine relevante und nützliche App-Sammlung für alle zu erhalten."
        },
        "reviewApps": {
            "heading": "Apps prüfen",
            "subHeading": "Prüfen Sie ausstehende App-Onboarding-Anfragen und genehmigen oder lehnen Sie sie ab. Ihre zeitnahen Prüfungen helfen uns, eine relevante und nützliche App-Sammlung für alle zu erhalten."
        },
        "reviewQnA": {
            "heading": "Q&A prüfen",
            "subHeading": "Prüfen Sie ausstehende QnA-Onboarding-Anfragen und genehmigen oder lehnen Sie sie ab. Ihre zeitnahen Prüfungen helfen uns, eine relevante und nützliche QnA-Sammlung für alle zu erhalten."
        },
        "reviewQueue": {
            "heading": "Überprüfungs-Warteschlange",
            "subHeading": "Überprüfen und genehmigen oder lehnen Sie ausstehende App-Integrationsersuchen ab. Ihre zeitnahe Überprüfung trägt dazu bei, dass wir eine relevante und nützliche App-Sammlung für alle beibehalten."
        },
        "activityLog": {
            "heading": "Aktivitätsprotokoll"
        },
        "quickActions": {
            "title": "Schnellaktionen",
            "onboardNewApp": "Neue App integrieren",
            "manageApps": "Apps verwalten",
            "defaultApps": "Standard-Apps",
            "onboardNewQnA": "Neue Frage & Antwort integrieren",
            "manageQnA": "Fragen & Antworten verwalten",
            "reviewerDashboard": "Reviewer-Dashboard",
            "reviewApps": "Integrierte Apps prüfen",
            "reviewQnA": "Integrierte Q&A prüfen"
        }
    },
    "sourceSelector": {
        "title": "Quelle auswählen",
        "allSources": "Alle Quellen",
        "allSourcesDesc": "Suche in allen internen E.ON-Informationsquellen",
        "eonKnowledgeBase": "E.ON Wissensdatenbank",
        "eonKnowledgeBaseDesc": "Zugriff auf allgemeines Unternehmenswissen",
        "eonMyItOrder": "E.ON Meine IT-Bestellungen",
        "eonMyItOrderDesc": "IT-Servicebestellungen verwalten und verfolgen",
        "eonItKnowledgeBase": "E.ON IT-Wissensdatenbank",
        "eonItKnowledgeBaseDesc": "IT-bezogene Informationen und Lösungen finden",
        "myGenius": "My Genius",
        "myGeniusDesc": "Interne Lernkurse und Materialien erkunden",
        "confluenceAll": "Confluence (Alle)",
        "confluenceAllDesc": "Kollaborative Dokumentation durchsuchen",
        "sharepointAll": "SharePoint (Alle)",
        "sharepointAllDesc": "Gemeinsame Dateien und Ressourcen durchsuchen",
        "eonApps": "E.ON Apps",
        "eonAppsDesc": "Unternehmensanwendungen entdecken und nutzen",
        "hrPolicies": "HR-Richtlinien",
        "hrPoliciesDesc": "Zugriff auf HR-Richtlinien und -Leitfäden",
        "compass": "Compass",
        "compassDesc": "E.ON-Intranet erkunden",
        "back": "Zurück",
        "search": "Suchen...",
        "noMatches": "Keine Treffer"
    },
    "ailoader": {
        "thinking": "Denken",
        "reading": "Quellen lesen",
        "processing": "Verarbeitung",
        "analysing": "Ergebnisse analysieren",
        "preparing": "Antwort vorbereiten",
        "working": "Wir arbeiten an Ihrer Antwort – dies kann einen Moment dauern."
    },
    "compassScopeSelector": {
        "title": "Geschäftsbereich auswählen",
        "iconLabel": "Suchbereich",
        "localSearch": "Lokale Suche",
        "compassWideSearch": "Unternehmensweite Compass-Suche",
        "resetToCompassWide": "Zur unternehmensweiten Suche zurücksetzen",
        "switchToLocal": "Zur lokalen Suche wechseln",
        "localDescription": "Suche innerhalb Ihres Unternehmens und öffentlichen Beiträgen",
        "compassWideDescription": "Suche über alle Geschäftsbereiche"
    },
    "errorMessages": {
        "azureAiContentViolation": "Die Antwort wurde gefiltert, da die Anfrage die Inhaltsrichtlinien von Azure OpenAI ausgelöst hat. Bitte ändern Sie Ihre Anfrage und versuchen Sie es erneut."
    }
}
